// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-01T19:37:27.363Z
// Property: Lakefront Villas (ID: 6300377863421952)
// Collections: 16 amenities, 25 floorplans (live), 23 photos, 78 POIs, 4 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6300377863421952",
  "property_external_id": "4576999",
  "property_zillow_url": "https://www.zillow.com/apartments/houston-tx/1895-barker-cypress-rd/5XhsMq/",
  "property_apartments_url": "https://www.apartments.com/lakefront-villas-houston-tx/pn7r16s",
  "property_google_business_url": "https://www.google.com/maps/place/Lakefront+Villas/@29.7955707,-95.6906605,15z/data=!4m2!3m1!1s0x0:0x488b183d18819d22?sa=X&ved=2ahUKEwisv5msiuL2AhXZlmoFHYGBBh8Q_BJ6BAgiEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443916050",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "lakefront-villas",
  "property_name": "Lakefront Villas",
  "property_website_url": "https://www.lakefrontvillasliving.com/",
  "property_domain": "https://www.lakefrontvillasliving.com/",
  "property_address": "1895 Barker Cypress Rd",
  "property_full_address": "1895 Barker Cypress Rd, Houston, TX 77084",
  "property_address_1": "1895 Barker Cypress Rd",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77084-6828",
  "property_address_zip": "77084",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Addicks Park Ten",
  "property_address_latitude": "29.795624",
  "property_address_longitude": "-95.69099779999999",
  "property_email": "lakefront@alapts.com",
  "property_phone": "(281) 579-2787",
  "property_call_tracking_phone": "832-915-3735",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Lakeside calm in West Houston.</strong> Discover gated apartment living with a community fishing lake, resort-inspired pool, and spacious one, two, and three bedroom homes with polished everyday finishes—then schedule your tour of Lakefront Villas.</p>",
  "property_long_description": "<p><strong>Lakeside calm in West Houston.</strong> At Lakefront Villas, you get more than an apartment—you get a green, gated setting with a community fishing lake, lakeside gazebo, resort-inspired pool with heated spa, outdoor fire pit, bark park, and 24-hour fitness center. Choose from spacious one, two, and three bedroom <a href=\"/floor-plans\">floor plans</a> with everyday conveniences like in-home washers and dryers, granite countertops, stainless steel appliances, walk-in closets, and private patios or balconies, with select homes offering lake views, kitchen islands, built-ins, wood-style flooring, and private garages.</p><p>Set in the Bear Creek/Copperfield area near Cullen Park, Lakefront Villas keeps West Houston practical and relaxed. Weekend trails, fishing, and wide-open parkland are close by at Cullen Park and Bear Creek Pioneers Park, while I-10, Highway 6, the Energy Corridor, Houston Methodist West, Texas Children’s West Campus, and Barker Cypress shopping and dining make daily plans easier. Explore more local highlights on the <a href=\"/neighborhood\">neighborhood</a> page or see the community’s standout <a href=\"/amenities\">amenities</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019d02f6-394b-71df-a975-51a271e4be9f.webp",
  "property_featured_image_media": {
    "alt_text": "A stylish living room with navy blue accent wall, sectional sofa, coffee table, and entertainment center.",
    "public_id": "019d02f6-394b-71df-a975-51a271e4be9f",
    "storage_key": "property/6300377863421952/019d02f6-394b-71df-a975-51a271e4be9f.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "234",
  "property_year_built": "2008",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.00854700854701",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8091990.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://lakefrontvillas.loftliving.com/login",
  "property_apply_now_url": "https://8091990.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e6fba-070d-779d-b0b4-09cddc704d17.webp",
  "property_primary_logo_media": {
    "alt_text": "Lakefront Villas Premier Apartments logo",
    "public_id": "019e6fba-070d-779d-b0b4-09cddc704d17",
    "storage_key": "property/6300377863421952/019e6fba-070d-779d-b0b4-09cddc704d17.webp",
    "width": 2116,
    "height": 1114
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e6fba-0708-753f-a40b-00cc71ca39d0.webp",
  "property_secondary_logo_media": {
    "alt_text": "Lakefront Villas Premier Apartments logo",
    "public_id": "019e6fba-0708-753f-a40b-00cc71ca39d0",
    "storage_key": "property/6300377863421952/019e6fba-0708-753f-a40b-00cc71ca39d0.webp",
    "width": 2116,
    "height": 1114
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e6fba-0634-703d-8374-4a8779a2cdbb.webp",
  "property_icon_media": {
    "alt_text": "Lakefront Villas logo with Adirondack chair.",
    "public_id": "019e6fba-0634-703d-8374-4a8779a2cdbb",
    "storage_key": "property/6300377863421952/019e6fba-0634-703d-8374-4a8779a2cdbb.webp",
    "width": 1260,
    "height": 1260
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e6fba-0634-703d-8374-4a8779a2cdbb.webp",
  "property_fav_icon_media": {
    "alt_text": "Lakefront Villas logo with Adirondack chair.",
    "public_id": "019e6fba-0634-703d-8374-4a8779a2cdbb",
    "storage_key": "property/6300377863421952/019e6fba-0634-703d-8374-4a8779a2cdbb.webp",
    "width": 1260,
    "height": 1260
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f42df-6ce3-73ef-acfd-acff018dcdb8.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f42df-6ce3-73ef-acfd-acff018dcdb8",
    "storage_key": "property/6300377863421952/019f42df-6ce3-73ef-acfd-acff018dcdb8.webp",
    "width": 1280,
    "height": 673
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f42df-57a4-778e-9485-c205500dfc7e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f42df-57a4-778e-9485-c205500dfc7e",
    "storage_key": "property/6300377863421952/019f42df-57a4-778e-9485-c205500dfc7e.webp",
    "width": 1280,
    "height": 673
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#18547d",
  "property_secondary_color": "#e8ba3e",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#b1c3da",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "727 - 1454",
  "property_sqft_min": "727",
  "property_sqft_max": "1454",
  "property_price_range": "991.83 - 2522.66",
  "property_price_min": "991.83",
  "property_price_max": "2522.66",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/lakefrontvillastx",
  "property_instagram_url": "https://www.instagram.com/lakefrontvillas",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFelr5_zYQIYRIp2BGD0Yi0g",
  "property_youtube_url": "https://www.youtube.com/watch?v=dhunQbBP7q0",
  "property_yelp_url": "https://www.yelp.com/biz/newport-on-the-lake-by-cortland-houston",
  "property_tiktok_url": "https://www.tiktok.com/@lakefrontvillas",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Lakeside amenities, everyday polish.</strong> Start with coffee on a private patio or balcony, then head to the 24-hour fitness center, resort-inspired pool, outdoor fire pit, or community fishing lake with a dock and gazebo. Inside, granite countertops, stainless steel appliances, walk-in closets, and in-home washer and dryer convenience keep daily routines streamlined, with select homes offering lake views, kitchen islands, built-in desks, private garages, and more.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the space that fits your day.</strong> Lakefront Villas offers one, two, and three bedroom apartments in Houston with open living areas, walk-in closets, in-home washers and dryers, and patios or balconies. Inside, polished finishes include granite countertops, stainless steel appliances, undermount sinks, and gooseneck faucets, with select layouts adding kitchen islands, built-ins, wood-style flooring, lakeside views, extra storage, or private garages.</p>",
  "property_home_gallery_blurb": "<p><strong>Lakeside living, frame by frame.</strong> Preview bright interiors with stainless-steel kitchens, granite countertops, private balconies, walk-in closets, and polished baths. Then step outside through the gallery to see the sparkling pool and spa, lakeside gazebo, fishing lake, outdoor fire pit, and green spaces that shape the relaxed Lakefront Villas setting.</p>",
  "property_home_neighborhood_blurb": "<p><strong>West Houston convenience, minutes from the parks.</strong> Lakefront Villas places you near Barker Cypress essentials and the open-air space of Cullen Park, George Bush Park, and Bear Creek Pioneers Park, with trails, picnic areas, sports fields, and reservoir views close by. Highway 6 and I-10 keep shopping, dining, the Energy Corridor, Katy, and greater Houston within easy reach. Explore the map to see what’s nearby, then schedule a tour around the lake.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at Lakefront Villas.</strong> Reviews often point to the quiet, well-kept setting, responsive maintenance, and helpful office team. Spacious layouts and relaxing outdoor spaces—like the lake, pool, and putting green—add to the everyday appeal, while clean grounds and prompt service keep earning praise.</p>",
  "property_neighborhood_blurb": "<p><strong>Your West Houston map starts close to green space.</strong> From Lakefront Villas, you’re positioned between the everyday ease of Barker Cypress and the open-air pull of Cullen Park, George Bush Park, and Bear Creek Pioneers Park—places known for hike-and-bike trails, picnic areas, sports fields, and wide reservoir scenery. When plans call for errands, dinner, or a quick coffee, nearby shopping centers along Barker Cypress and Highway 6 keep the routine simple, while I-10 connects you to the Energy Corridor, Katy, and greater Houston. METRO’s Addicks Park &amp; Ride adds another option for downtown trips. Use the map below to explore what’s close, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits around the lake.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces with a lakeside point of view.</strong> At Lakefront Villas, your day can move easily from coffee on a private patio or balcony to a workout in the 24-hour fitness center, a swim in the resort-inspired pool, or an evening by the outdoor fire pit. The community fishing lake, dock, and lakeside gazebo add a setting that feels distinctly relaxed for Houston apartment living.</p><p>Inside, polished details keep everyday routines simple and streamlined: granite countertops, stainless steel appliances, undermount sinks with gooseneck faucets, walk-in closets, and in-home washer and dryer convenience. Select homes add extras like kitchen islands, built-in desks, wood-style flooring, lake views, additional storage, or private garages, so you can choose the finish level and features that fit the way you use your space.</p>",
  "property_applynow_blurb": "<p><strong>Start your Lakefront Villas application online.</strong> Settle into lakeside calm with spacious one, two, and three bedroom apartments, in-home washers and dryers, granite countertops, stainless steel appliances, walk-in closets, and private patios or balconies—all in a green, gated West Houston setting. Apply now and take the next step toward home.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact the Lakefront Villas leasing team for details about our gated lakeside setting, spacious one, two, and three bedroom homes, or everyday conveniences. Need directions to 1895 Barker Cypress Rd? Reach out and we’ll help you find your way.</p>",
  "property_faqs_blurb": "<p><strong>Questions before you choose Lakefront Villas?</strong> Start here for quick answers about the community, leasing, floor plans, everyday features, and life in this green, gated West Houston setting. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the layout that feels right.</strong> Lakefront Villas gives you a wide range of one, two, and three bedroom apartments in Houston, from streamlined spaces that keep daily life simple to larger layouts with extra room for work, hobbies, or storage. As you compare availability, look for open living areas, walk-in closets, in-home washer and dryer convenience, and private patios or balconies that extend your space outdoors.</p><p>Each plan pairs practical flow with polished <a href=\"/amenities\">interior finishes</a> like granite countertops, stainless steel appliances, and undermount sinks with gooseneck faucets, while select homes add kitchen islands, built-in shelving or desks, wood-style flooring, lakeside views, additional storage, or private garages. Browse the cards below, compare your options, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the layouts in person.</p>",
  "property_gallery_blurb": "<p><strong>See the lakeside details come into focus.</strong> Browse the Photo Gallery for a closer look at Lakefront Villas in Houston, from bright living rooms and stainless-steel kitchens with granite countertops to private balconies, walk-in closets, and polished bath finishes. Outside, the camera moves through the <a href=\"/amenities\">community amenities</a> that give the property its relaxed visual character: a sparkling pool and spa, a lakeside gazebo, a community fishing lake, an outdoor fire pit, and green spaces designed for everyday breathing room. As you scroll, picture how each scene fits your routine—morning coffee by the water, an afternoon workout, or an evening beside the poolside grill. Like what you see? Explore the <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore West Houston from the map.</strong><br>Find available one, two, and three bedroom apartments at Lakefront Villas, then see how the green gated setting connects to nearby parks, major routes, shopping, dining, and everyday destinations around Bear Creek/Copperfield.</p>",
  "property_pets_blurb": "<p><strong>Let tails set the pace.</strong> At Lakefront Villas, pet-friendly apartment living in Houston feels easy from the first morning walk to the last lap before bed. Cats and dogs are welcome here, with room for up to two pets per home and no weight limit, while the community’s <a href=\"/amenities\">Bark Park</a> gives dogs a convenient place to stretch, sniff, and play close to home.</p><p>When you want a calmer routine, take the leash through the gated community, follow the walking and biking trails, or unwind by the lake after a busy day. Private patios and balconies in many homes add a little fresh-air space for you and your companion, and nearby off-leash parks and pet supply options make errands and weekend outings simple. Have questions about breed guidelines or current availability? <a href=\"/contact-us\">Contact the leasing team</a> before you tour.</p>",
  "property_referafriend_blurb": "<p><strong>Share lakeside calm in West Houston.</strong> Love the green, gated setting, fishing lake, resort-inspired pool, and spacious homes with everyday conveniences? Refer a friend to Lakefront Villas and invite them to experience the relaxed lifestyle you already enjoy.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your Lakefront Villas account—so you can get back to the lakeside calm, gated green setting, and everyday ease that make home feel relaxed.</p>",
  "property_reviews_blurb": "<p><strong>Residents say it best.</strong> As you read through reviews for Lakefront Villas, you’ll see a consistent appreciation for a quiet, well-kept apartment community with responsive service and welcoming support from the office team.</p><p>Reviewers often highlight prompt maintenance, spacious layouts, and relaxing outdoor spaces—from time by the lake to the pool and putting green. One resident sums up the service experience simply: “The service team is seriously AMAZING.” Others mention the clean grounds, comfortable community feel, and helpful staff as reasons they continue to call Lakefront Villas home.</p>",
  "property_created_at": "1752256802617",
  "property_scheduletour_blurb": "<p><strong>See lakeside calm up close.</strong> Tour Lakefront Villas and experience the gated green setting, community fishing lake, resort-inspired pool, and spacious one, two, and three bedroom homes with polished everyday finishes. Schedule your visit today and picture your next chapter in West Houston.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> A Lakefront Villas leasing team member will follow up soon. In the meantime, picture lakeside calm in a green, gated West Houston setting, with spacious apartment homes and everyday comforts designed to make home feel easy.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Lakefront Villas before you arrive.</strong> These virtual tours let you move room by room through the spaces that shape daily life here in Houston: start with the community tour, then step inside the modern 24-hour fitness center and dedicated spin room to see the workout areas in motion.</p><p>Ready to compare homes? Tour a spacious two-bedroom, two-bath apartment and the A5 one-bedroom, one-bath layout, noticing the open living flow, bright windows, granite countertops, stainless steel appliances, walk-in closets, and in-home laundry details along the way. After you explore online, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Lakefront Villas",
  "property_seo_title_home": "Lakefront Villas | Apartments in Houston, TX",
  "property_seo_description_home": "\"Discover luxurious living at Lakefront Villas in Houston, TX! Choose from spacious one, two, and three-bedroom floor plans, all featuring modern amenities like stainless appliances, garden tubs, and built-in desks. Enjoy exclusive access to our fitness center, pool, dog park, and serene lake views. With convenient online resident services and covered parking, your comfort is our priority. Find your new home today and experience the perfect blend of leisure and sophistication!\"",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Houston, TX",
  "property_seo_description_floorplans": "Discover your ideal home at Lakefront Villas in Houston, TX! Explore our thoughtfully designed floor plans featuring spacious one, two, and three-bedroom apartments. Whether you're seeking a cozy retreat or a family-friendly layout, we have the perfect space for you. Browse our available apartment homes today and find your dream floor plan!",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at Lakefront Villas in Houston, TX! Choose from spacious one, two, and three-bedroom floor plans, all designed with your comfort in mind. Enjoy exceptional amenities such as a state-of-the-art fitness center, serene lake and pool views, a relaxing fire pit, a dog park, and convenient online resident services. Explore our beautiful community today and experience modern living with built-in desks, stainless appliances, and expansive outdoor spaces. Don’t miss out – explore our amazing community amenities and apartment features now!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "Discover your dream home at Lakefront Villas in Houston, TX! Our stunning apartments feature spacious one, two, and three-bedroom floor plans with gorgeous lake and pool views. Enjoy an array of premium amenities, including a fitness center, dog park, fire pit, and covered parking, all within a beautiful community setting. With convenient online resident services, first-class features like kitchen islands, stainless appliances, and garden tubs, you'll find everything you need right at your fingertips. Explore our photo gallery and picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Lakefront Villas Apartments",
  "property_seo_description_virtualtours": "\"Discover your ideal home at Lakefront Villas in Houston, TX! Explore our diverse floor plans featuring one, two, and three-bedroom apartments. Experience the charm of our community with a captivating virtual tour. Take the first step to your new lifestyle—schedule your virtual tour today!\"",
  "property_seo_title_interactivemap": "Interactive Map | Lakefront Villas Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Lakefront Villas in Houston, TX! Our diverse floor plans feature one, two, and three-bedroom apartments tailored to your lifestyle. Enjoy a range of premium amenities including access gates, a fitness center, serene lake views, and a relaxing pool. Experience convenience with online resident services, covered parking, and on-site dog park. Explore our interactive community map to find your perfect apartment today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Lakefront Villas in Houston, TX. Explore our range of spacious one, two, and three-bedroom floor plans, while immersing yourself in local favorites and nearby points of interest. See what's around our community today!",
  "property_seo_title_contact": "Contact Us | Lakefront Villas",
  "property_seo_description_contact": "Explore the serene lifestyle at Lakefront Villas in Houston, TX! Our community offers a variety of floor plans, including one, two, and three-bedroom apartments tailored to your needs. Have questions? Contact our leasing team today to learn more about your new home and schedule a tour!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "Discover the comforts of Lakefront Villas in Houston, TX! Explore our spacious one, two, and three-bedroom floor plans and indulge in luxurious amenities, including a resort-style pool, fitness center, dog park, and stunning lake views. Our community offers convenient online resident services, covered parking, and beautifully designed spaces like garden tubs and kitchen islands. Have questions? Browse our FAQs page for all the answers about our welcoming apartment community and lifestyle. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "Experience the serene lifestyle at Lakefront Villas in Houston, TX! Discover a variety of spacious floor plans including one, two, and three-bedroom apartments, complete with resort-style amenities such as a fitness center, pool, and stunning lake views. Our community features secure access gates, a dog park, and a resident clubhouse perfect for gatherings. Don’t just take our word for it—see what our residents have to say about life at Lakefront Villas! Join our vibrant community today and elevate your living experience!",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "\"Welcome to Lakefront Villas, your premier apartment community in Houston, TX! Choose from spacious one, two, and three-bedroom floor plans featuring amenities like a fitness center, dog park, and stunning lake views. Enjoy resort-style living with covered parking, a fire pit, and a sparkling pool. Apply now and find your new home—leasing is easy with our online resident services!\"",
  "property_seo_title_residentaccess": "Resident Access | Lakefront Villas",
  "property_seo_description_residentaccess": "\"Access your resident portal at Lakefront Villas in Houston, TX! Easily pay rent, schedule maintenance, and stay connected with our vibrant community. Sign in now for seamless living!\"",
  "property_seo_title_referafriend": "Refer A Friend | Lakefront Villas",
  "property_seo_description_referafriend": "\"Refer a friend to Lakefront Villas in Houston, TX, and enjoy the perfect blend of comfort and community! Great friends make great neighbors—spread the word and enhance your living experience today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Lakefront Villas",
  "property_seo_description_scheduletour": "\"Discover your dream home at Lakefront Villas in Houston, TX! Enjoy stunning amenities, beautiful waterfront views, and a vibrant community. Schedule a tour of our apartment community today and see why Lakefront Villas is the perfect place to call home!\"",
  "property_seo_title_privacy": "Privacy Policy | Lakefront Villas",
  "property_seo_description_privacy": "\"Discover how Lakefront Villas in Houston, TX prioritizes your privacy and security. Our comprehensive privacy policy outlines data protection practices and resident rights. View our privacy policy today to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | Lakefront Villas",
  "property_seo_description_accessibility": "Discover Lakefront Villas in Houston, TX, where we prioritize digital inclusion for all. Our Accessibility Statement outlines our commitment to creating an inclusive community that meets the needs of every resident. Learn more about our efforts and how we can enhance your living experience. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Lakefront Villas",
  "property_seo_description_sitemap": "Discover the layout of Lakefront Villas in Houston, TX, with our comprehensive sitemap. Explore our vibrant apartment community, amenities, and nearby attractions. View our website sitemap to find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Lakefront Villas",
  "property_seo_description_thankyou": "Thank you for reaching out to Lakefront Villas in Houston, TX! Your inquiry is important to us. A team member will be in touch shortly to assist you in finding your perfect home by the lake. Stay tuned for updates and exciting community news!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786983540424",
  "amenities": [
    {
      "id": "custom_c2369459-7cf6-4883-9955-cd0a1ac7c022",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Inspired Pool w/ Heated Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_497df46a-3eb3-481b-8bc3-fced10a3e833",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Modern 24‑Hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1cac3f4e-261e-4a01-9716-8b1aa7fc8986",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse w/ WiFi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6bbac0b-0c37-4f20-a9d9-11edc9b4e52b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Community Fishing Lake",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc394f7d-8529-461b-b5cc-0d2e3ca39349",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Community Dock",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_04ae2495-573b-45f6-a00a-e62b2a4d0183",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Lakeside Gazebo",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7eec7023-0e19-4c1b-b65f-05ef4ff86e39",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park For Your Furry Friends",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_46a8bd5b-a7f6-4843-aae2-d129caa08fff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Firepit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_44ac6179-b8ad-42d4-afc0-12aa93ff1469",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Gas Grill",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_127e732a-b8ce-4615-a9a3-eb495fc1a34b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f4f0f26-2047-4f76-8e70-557440e9558b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Gated, Limited Access Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ac6a4a75-f7bb-4577-99da-2362a236cbbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Virtual Moving Concierge by Updater",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0ef3bdc3-4617-48dd-b2fb-2438a86ba3a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Credit Building Services Powered by RentPlus",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_434c84ce-e6db-43a5-b06b-2e01fb715c8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Concierge Cleaning Services Available by Spruce",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2dab88dd-33be-4e1f-8a50-693e2b515b4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7d27c9e-9fb6-4d33-a86f-d5e8e341589f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_917ed880-af79-49e2-ab7f-415de84a248e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-beae-748d-a015-5febfb14ed7e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with kitchen, seating, and a fireplace.",
        "public_id": "019e899d-beae-748d-a015-5febfb14ed7e",
        "storage_key": "property/6300377863421952/019e899d-beae-748d-a015-5febfb14ed7e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious and modern lounge area featuring a fully equipped kitchen, comfortable seating arrangements, and elegant decor. Perfect for residents to relax and socialize.",
      "link": "",
      "alt_text": "Modern lounge area with kitchen, seating, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_614f3fa3-4e26-445b-8d80-8994d30617f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-cb51-704c-ab2d-f114de2237f5.webp",
      "image_media": {
        "alt_text": "Stylish living room with a navy accent wall, modern black credenza, sectional sofa, and coffee table.",
        "public_id": "019e899d-cb51-704c-ab2d-f114de2237f5",
        "storage_key": "property/6300377863421952/019e899d-cb51-704c-ab2d-f114de2237f5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room, featuring a chic navy accent wall, elegant furnishings, and a cozy atmosphere.",
      "link": "",
      "alt_text": "Stylish living room with a navy accent wall, modern black credenza, sectional sofa, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f60b030-248c-4c05-8afe-f8763a102af0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-c344-7545-bccb-9e639aee6e7c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with bathtub, vanity with granite countertop, and stainless steel sink.",
        "public_id": "019e899d-c344-7545-bccb-9e639aee6e7c",
        "storage_key": "property/6300377863421952/019e899d-c344-7545-bccb-9e639aee6e7c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish bathroom, featuring a spacious bathtub and a chic vanity with a granite countertop and stainless steel sink.",
      "link": "",
      "alt_text": "Modern bathroom with bathtub, vanity with granite countertop, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3dc2b1cb-0043-48cb-a47a-1ce7000669cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-bf7c-71ad-a8e3-8afdbfc554d9.webp",
      "image_media": {
        "alt_text": "Dog park with tunnel and seating area.",
        "public_id": "019e899d-bf7c-71ad-a8e3-8afdbfc554d9",
        "storage_key": "property/6300377863421952/019e899d-bf7c-71ad-a8e3-8afdbfc554d9.webp",
        "width": 2520,
        "height": 1680
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, a dedicated space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with tunnel and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16bdf42b-0472-44c8-b83a-4d567ef1b836",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-bd23-7778-b2a7-d2d179d722d2.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit area with seating and palm trees.",
        "public_id": "019e899d-bd23-7778-b2a7-d2d179d722d2",
        "storage_key": "property/6300377863421952/019e899d-bd23-7778-b2a7-d2d179d722d2.webp",
        "width": 2781,
        "height": 1854
      },
      "title": "Community",
      "description": "Relax by the fire pit in this inviting outdoor seating area, surrounded by lush palm trees and string lights. Perfect for evening gatherings.",
      "link": "",
      "alt_text": "Outdoor fire pit area with seating and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4b16100-e7af-47d9-9511-994cb4063d02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-c6f6-7644-83c7-79cc1b00e54f.webp",
      "image_media": {
        "alt_text": "Lakefront Villas Premier Apartments monument sign.",
        "public_id": "019e899d-c6f6-7644-83c7-79cc1b00e54f",
        "storage_key": "property/6300377863421952/019e899d-c6f6-7644-83c7-79cc1b00e54f.webp",
        "width": 2695,
        "height": 1797
      },
      "title": "Community",
      "description": "Welcome to Lakefront Villas, premier apartments offering a refined living experience. This monument sign marks the entrance to our beautiful community.",
      "link": "",
      "alt_text": "Lakefront Villas Premier Apartments monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_338a9d50-1566-4231-85bd-20ead723a4c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-a7d6-779c-9f08-514874ddce00.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a blue accent wall and modern furniture.",
        "public_id": "019e899d-a7d6-779c-9f08-514874ddce00",
        "storage_key": "property/6300377863421952/019e899d-a7d6-779c-9f08-514874ddce00.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living and dining space featuring a comfortable sofa, a glass-top dining table, and a modern kitchen counter. The deep blue accent wall adds a dramatic flair to the room.",
      "link": "",
      "alt_text": "Living room and dining area with a blue accent wall and modern furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe5d4c20-075a-40aa-9775-67e45ab70006",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-a83e-76d5-a5b7-20973302a77f.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating and tables next to a swimming pool.",
        "public_id": "019e899d-a83e-76d5-a5b7-20973302a77f",
        "storage_key": "property/6300377863421952/019e899d-a83e-76d5-a5b7-20973302a77f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our resort-style pool area, complete with comfortable seating, shaded pergolas, and a refreshing swimming pool.",
      "link": "",
      "alt_text": "Outdoor lounge area with seating and tables next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_039a89cc-7fef-44ec-bfd4-dc09508d29ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-a656-779d-9df9-85179f6c56f8.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a large bed, navy accent wall, and walk-in closet.",
        "public_id": "019e899d-a656-779d-9df9-85179f6c56f8",
        "storage_key": "property/6300377863421952/019e899d-a656-779d-9df9-85179f6c56f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom, featuring a comfortable bed, stylish decor, and ample storage with a walk-in closet.",
      "link": "",
      "alt_text": "Modern bedroom with a large bed, navy accent wall, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4e7ba3e7-93dd-40c6-a849-e175f1124dda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-a281-741d-a412-d4dd7a8c8780.webp",
      "image_media": {
        "alt_text": "Spinning bikes in a fitness center with TVs and motivational wall art.",
        "public_id": "019e899d-a281-741d-a412-d4dd7a8c8780",
        "storage_key": "property/6300377863421952/019e899d-a281-741d-a412-d4dd7a8c8780.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, motivational wall art, and entertainment options.",
      "link": "",
      "alt_text": "Spinning bikes in a fitness center with TVs and motivational wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eee46b91-2029-494d-a3fb-3272611b60a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-a505-706c-af05-98e9b3f39d93.webp",
      "image_media": {
        "alt_text": "Smart package lockers with \"Lakefront Villas Premier Apartments\" branding.",
        "public_id": "019e899d-a505-706c-af05-98e9b3f39d93",
        "storage_key": "property/6300377863421952/019e899d-a505-706c-af05-98e9b3f39d93.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient package lockers are available for residents at Lakefront Villas. Secure and easy access to your deliveries.",
      "link": "",
      "alt_text": "Smart package lockers with \"Lakefront Villas Premier Apartments\" branding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_965c56be-f1e3-435b-97d7-7fc284257aad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-9ac4-771d-9232-d122cb5fe307.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with chairs and a fire pit surrounded by palm trees.",
        "public_id": "019e899d-9ac4-771d-9232-d122cb5fe307",
        "storage_key": "property/6300377863421952/019e899d-9ac4-771d-9232-d122cb5fe307.webp",
        "width": 3024,
        "height": 2016
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor seating area, complete with comfortable chairs and a cozy fire pit, perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Outdoor seating area with chairs and a fire pit surrounded by palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_309d98ef-529d-4b42-8156-564bd578b71e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-a58a-7370-a88f-8d88d1208736.webp",
      "image_media": {
        "alt_text": "Stylish modern lounge area with vaulted ceilings, exposed beams, fireplace, and kitchen island.",
        "public_id": "019e899d-a58a-7370-a88f-8d88d1208736",
        "storage_key": "property/6300377863421952/019e899d-a58a-7370-a88f-8d88d1208736.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed resident lounge, featuring a cozy fireplace, ample seating, and a full-service kitchen.",
      "link": "",
      "alt_text": "Stylish modern lounge area with vaulted ceilings, exposed beams, fireplace, and kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2424557-8372-4013-b207-43af6d52c9b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-a648-773a-8980-731b7442b1e0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with in-water loungers and a covered cabana area.",
        "public_id": "019e899d-a648-773a-8980-731b7442b1e0",
        "storage_key": "property/6300377863421952/019e899d-a648-773a-8980-731b7442b1e0.webp",
        "width": 2812,
        "height": 1875
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip or relax by the sparkling swimming pool, complete with comfortable in-water loungers and a shaded cabana perfect for sunny days.",
      "link": "",
      "alt_text": "Resort-style swimming pool with in-water loungers and a covered cabana area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82c1be00-79f6-4564-a14d-057ae8079fd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-9b80-7720-9835-3814c5574348.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, blue headboard, and modern art.",
        "public_id": "019e899d-9b80-7720-9835-3814c5574348",
        "storage_key": "property/6300377863421952/019e899d-9b80-7720-9835-3814c5574348.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-size bed and elegant decor. An ensuite bathroom and walk-in closet are accessible from the bedroom.",
      "link": "",
      "alt_text": "Luxurious bedroom with a king-size bed, blue headboard, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b7965cc-08a1-4c22-8112-030376f7e843",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-9b76-761e-a77f-a0ac0149dd54.webp",
      "image_media": {
        "alt_text": "Living and dining area with a large window and a dining table set for four.",
        "public_id": "019e899d-9b76-761e-a77f-a0ac0149dd54",
        "storage_key": "property/6300377863421952/019e899d-9b76-761e-a77f-a0ac0149dd54.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Experience modern living in this spacious apartment, featuring a stylish dining area and a comfortable living room, perfect for entertaining.",
      "link": "",
      "alt_text": "Living and dining area with a large window and a dining table set for four.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_05b269e6-cca0-4d8b-8fec-e63bc3c65190",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-4f1b-72aa-9729-168413f8dc16.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a separate laundry area.",
        "public_id": "019e899d-4f1b-72aa-9729-168413f8dc16",
        "storage_key": "property/6300377863421952/019e899d-4f1b-72aa-9729-168413f8dc16.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, granite countertops, and a convenient in-unit laundry area with washer and dryer.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a separate laundry area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c68c2802-6ad0-43fe-ac99-1aad6132bce6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-5070-706e-9bae-51b566af1735.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with treadmills, a stair climber, a cable crossover machine, and free weights.",
        "public_id": "019e899d-5070-706e-9bae-51b566af1735",
        "storage_key": "property/6300377863421952/019e899d-5070-706e-9bae-51b566af1735.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, strength-training equipment, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fully equipped fitness center with treadmills, a stair climber, a cable crossover machine, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0a62de8-15ea-4031-824d-e7783653b647",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-511a-743a-a1cc-3d5cc8acefe8.webp",
      "image_media": {
        "alt_text": "Path with swings overlooking a pond and apartment buildings.",
        "public_id": "019e899d-511a-743a-a1cc-3d5cc8acefe8",
        "storage_key": "property/6300377863421952/019e899d-511a-743a-a1cc-3d5cc8acefe8.webp",
        "width": 3024,
        "height": 2016
      },
      "title": "Community",
      "description": "Enjoy the serene views and fresh air by the pond, with comfortable swings available for relaxation.",
      "link": "",
      "alt_text": "Path with swings overlooking a pond and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_621a8f86-85e6-4529-9565-5dc1e359b3ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-4f36-76ce-ac2a-b36209c7ba3b.webp",
      "image_media": {
        "alt_text": "Fitness room with exercise bikes, stability balls, and resistance bands.",
        "public_id": "019e899d-4f36-76ce-ac2a-b36209c7ba3b",
        "storage_key": "property/6300377863421952/019e899d-4f36-76ce-ac2a-b36209c7ba3b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and strength training equipment for a great workout.",
      "link": "",
      "alt_text": "Fitness room with exercise bikes, stability balls, and resistance bands.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3b8160f-0a62-44db-b87e-e640b3effbb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-4ed2-75a9-bbef-92c3947cf767.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e899d-4ed2-75a9-bbef-92c3947cf767",
        "storage_key": "property/6300377863421952/019e899d-4ed2-75a9-bbef-92c3947cf767.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6b4e856-89cd-4e77-8496-f5a9070b8787",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-4fc5-765a-86c3-2533c2a3adba.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "019e899d-4fc5-765a-86c3-2533c2a3adba",
        "storage_key": "property/6300377863421952/019e899d-4fc5-765a-86c3-2533c2a3adba.webp",
        "width": 2323,
        "height": 1549
      },
      "title": "Community",
      "description": "Relax and unwind by our resort-style swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Enjoy the perfect oasis for leisure and recreation.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and umbrellas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e9c2ccc-5fa0-422d-8055-9b7e932216eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019e899d-40f3-70ec-bb55-f3f0b485ebf7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet",
        "public_id": "019e899d-40f3-70ec-bb55-f3f0b485ebf7",
        "storage_key": "property/6300377863421952/019e899d-40f3-70ec-bb55-f3f0b485ebf7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully appointed bathroom, featuring a spacious vanity, a convenient toilet, and a generous walk-in closet.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_c96f1d23db64c779d036c55e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Pho Tau Bay",
      "poi_type": "Restaurants",
      "poi_address": "6965 Barker Cypress Rd Unit C, Houston, TX 77084, USA",
      "poi_short_description": "Vietnamese options at a casual spot serving pho, vermicelli noodle bowls and spring rolls along with sandwiches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ce35-7358-888d-64f823a6185c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ce35-7358-888d-64f823a6185c",
        "storage_key": "property/6300377863421952/019f1505-ce35-7358-888d-64f823a6185c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://photaubay.kwickmenu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13893011614575256185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-tau-bay",
      "poi_latitude": "29.87893099999999",
      "poi_longitude": "-95.683723",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-550-2949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9AglgvXQIYReWIig3TkzcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "ec_316b6684e79b19c5ef4e707b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Triple S Pho & Grill - Cypress",
      "poi_type": "Restaurants",
      "poi_address": "7955 Barker Cypress Rd #900, Cypress, TX 77433, USA",
      "poi_short_description": "Casual Vietnamese eatery in a strip-mall with classic grub such as pho noodles & veggie options.",
      "poi_long_description": "Casual Vietnamese eatery in a strip-mall with classic grub such as pho noodles & veggie options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d1e6-7273-bde2-69582f326f10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d1e6-7273-bde2-69582f326f10",
        "storage_key": "property/6300377863421952/019f1505-d1e6-7273-bde2-69582f326f10.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17938940579890237714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "triple-s-pho--grill---cypress",
      "poi_latitude": "29.8919865",
      "poi_longitude": "-95.6843877",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-246-4640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ981ZzgbXQIYREpEyr2nr8_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "ec_4af6c7811f6f1dd1aeb8802f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Taisho Japanese Grill and Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "9955 Barker Cypress Rd #102, Cypress, TX 77433, USA",
      "poi_short_description": "Japanese spot offering sushi and other fare, including hibachi meals cooked at tableside.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d8e9-7153-a7d9-1c724912dc65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d8e9-7153-a7d9-1c724912dc65",
        "storage_key": "property/6300377863421952/019f1505-d8e9-7153-a7d9-1c724912dc65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.itaisho.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15660733865263877999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taisho-japanese-grill-and-sushi-bar",
      "poi_latitude": "29.9225212",
      "poi_longitude": "-95.6884315",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-213-4537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbCZImDWQIYRb8_78HkaVtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_667982967881262fb2d4c827",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Ambriza",
      "poi_type": "Restaurants",
      "poi_address": "9945 Barker Cypress Rd Ste 123, Cypress, TX 77433, USA",
      "poi_short_description": "Colorful kitchen providing modern takes on traditional Mexican fare, margaritas & desserts.",
      "poi_long_description": "Colorful kitchen providing modern takes on traditional Mexican fare, margaritas & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d62a-7419-9994-24f7c711520f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d62a-7419-9994-24f7c711520f",
        "storage_key": "property/6300377863421952/019f1505-d62a-7419-9994-24f7c711520f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ambriza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6868637780453397377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ambriza",
      "poi_latitude": "29.9223343",
      "poi_longitude": "-95.6877541",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 832-952-3495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe61oIirXQIYRgZPAcqtNUl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_0595adb585c2adf3e0355dcf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "7Friday Sushi",
      "poi_type": "Restaurants",
      "poi_address": "18121 Tuckerton Rd Suite 100, Cypress, TX 77433, USA",
      "poi_short_description": "Cheerful spot for fresh sushi rolls, bao sandwiches, and poke bowls.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d196-72fa-b15f-9c966e544ab9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d196-72fa-b15f-9c966e544ab9",
        "storage_key": "property/6300377863421952/019f1505-d196-72fa-b15f-9c966e544ab9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.7fridaysushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13890342597956944891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7friday-sushi",
      "poi_latitude": "29.9201531",
      "poi_longitude": "-95.6894863",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-304-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7_f5VnXQIYR-0Ozp_9oxMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_fed22fff86ff4dea756ef13b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "R & R Sports Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1840 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "Relaxed hangout for burgers, beer, pool and shuffleboard plus karaoke.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d1e5-762a-9293-37c5fd420567.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d1e5-762a-9293-37c5fd420567",
        "storage_key": "property/6300377863421952/019f1505-d1e5-762a-9293-37c5fd420567.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12465146333145210173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "r--r-sports-bar--grill",
      "poi_latitude": "29.7954881",
      "poi_longitude": "-95.6880999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 281-578-2704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3e98-7029-81fd-3fb847aa589e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3e98-7029-81fd-3fb847aa589e",
        "storage_key": "property/6300377863421952/019f1506-3e98-7029-81fd-3fb847aa589e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH_1qUf3YQIYRPR1i_IsY_aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_b8cb02d208be7c40c359a5aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Firebirds Tacos, Empanadas & More",
      "poi_type": "Restaurants",
      "poi_address": "6172 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d07a-71ce-8e30-8a68381fe13a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d07a-71ce-8e30-8a68381fe13a",
        "storage_key": "property/6300377863421952/019f1505-d07a-71ce-8e30-8a68381fe13a.webp",
        "width": 1014,
        "height": 1280
      },
      "poi_business_url": "http://www.eatfirebirdshouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17192492244139525813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firebirds-tacos-empanadas--more",
      "poi_latitude": "29.8620968",
      "poi_longitude": "-95.6828187",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-345-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0zMOU1zXQIYRtUaYN5sAmO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_41ce41a3e217fd6f4247b014",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Big Ben's Eatery",
      "poi_type": "Restaurants",
      "poi_address": "5431 Barker Cypress Rd Ste 200, Houston, TX 77084, USA",
      "poi_short_description": "Pizzeria with make-your-own & specialty pies, also offering subs, pasta, burgers & salads.",
      "poi_long_description": "Pizzeria with make-your-own & specialty pies, also offering subs, pasta, burgers & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d687-7668-9ebb-f444d7c30386.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d687-7668-9ebb-f444d7c30386",
        "storage_key": "property/6300377863421952/019f1505-d687-7668-9ebb-f444d7c30386.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bigbenseatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11570001583704952678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-bens-eatery",
      "poi_latitude": "29.8525",
      "poi_longitude": "-95.6841667",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-858-1851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs7BPG37XQIYRZs9wzyPnkKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_921994753b3f633e19f5f372",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Island Spice Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "17802 W Little York Rd, Houston, TX 77084, USA",
      "poi_short_description": "Traditional Caribbean cuisine & drinks offered in an upbeat, colorful space with weekend DJs.",
      "poi_long_description": "Traditional Caribbean cuisine & drinks offered in an upbeat, colorful space with weekend DJs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d5c2-74fb-a41b-7f383a93fa45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d5c2-74fb-a41b-7f383a93fa45",
        "storage_key": "property/6300377863421952/019f1505-d5c2-74fb-a41b-7f383a93fa45.webp",
        "width": 1039,
        "height": 1280
      },
      "poi_business_url": "https://www.islandspice.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2327050085450099595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "island-spice-bar-and-grill",
      "poi_latitude": "29.8657275",
      "poi_longitude": "-95.681491",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-859-1499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT41BIETBXhQRi6vLNblXSyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "ec_91efafe071e3a36a798b7f27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Big W Cattle Co.",
      "poi_type": "Restaurants",
      "poi_address": "6172 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "Easygoing pub with a broad American grill menu & live bands, plus karaoke, trivia & bingo nights.",
      "poi_long_description": "Easygoing pub with a broad American grill menu & live bands, plus karaoke, trivia & bingo nights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-d42e-7175-9bba-b693fcc9f96d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-d42e-7175-9bba-b693fcc9f96d",
        "storage_key": "property/6300377863421952/019f1505-d42e-7175-9bba-b693fcc9f96d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bigwcattleco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5786139891706054389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-w-cattle-co",
      "poi_latitude": "29.8623101",
      "poi_longitude": "-95.6827581",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-550-1814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3e98-7029-81fd-3fb847aa589e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3e98-7029-81fd-3fb847aa589e",
        "storage_key": "property/6300377863421952/019f1506-3e98-7029-81fd-3fb847aa589e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZaZi3nXQIYR9UbbQZN_TFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_a6e2620fbe9f581bc6acaab7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Sushi Haya Cypress",
      "poi_type": "Restaurants",
      "poi_address": "24330 Northwest Fwy Ste 100, Cypress, TX 77429, USA",
      "poi_short_description": "Casual, friendly spot for all-you-can-eat, fresh sushi, plus ramen, hibachi, tempura and other Japanese eats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-dbc2-73a9-8395-517c948a1214.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-dbc2-73a9-8395-517c948a1214",
        "storage_key": "property/6300377863421952/019f1505-dbc2-73a9-8395-517c948a1214.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sushihayatexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2942618797001965849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-haya-cypress",
      "poi_latitude": "29.9575592",
      "poi_longitude": "-95.6755135",
      "poi_miles_from_property": "15.3 mi",
      "poi_walking_minutes": "5 hours 39 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 281-758-5204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDfEJ8QDVQIYRGYGwiDRI1ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_7fd8e37a0d3d67e4ba627c3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Tosca Italian Gourmet Cypress",
      "poi_type": "Restaurants",
      "poi_address": "17823 Longenbaugh Rd, Cypress, TX 77433, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-dba8-74d9-8b1b-7d570a8b1c1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-dba8-74d9-8b1b-7d570a8b1c1b",
        "storage_key": "property/6300377863421952/019f1505-dba8-74d9-8b1b-7d570a8b1c1b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.toscaitaliangourmet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12868114537883857946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tosca-italian-gourmet-cypress",
      "poi_latitude": "29.8959411",
      "poi_longitude": "-95.6852839",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-861-5277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0ff-74fc-82f1-ed7c88b1dbc8",
        "storage_key": "property/6300377863421952/019f1503-a0ff-74fc-82f1-ed7c88b1dbc8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4w97-XXQIYRGnSbd_65lLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_833f92372d3e51db6fbe4f4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "3003 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "Convenience store chain offering a selection of products for people on the go.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ded7-74c8-a0ca-ba2db520feeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ded7-74c8-a0ca-ba2db520feeb",
        "storage_key": "property/6300377863421952/019f1505-ded7-74c8-a0ca-ba2db520feeb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/houston/3003-barker-cypress-rd/2703595?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15876322443796305200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "29.8130187",
      "poi_longitude": "-95.6872948",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-599-3155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3e95-706e-9a98-e502b2ecb9b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3e95-706e-9a98-e502b2ecb9b3",
        "storage_key": "property/6300377863421952/019f1506-3e95-706e-9a98-e502b2ecb9b3.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ6fBGrqzZQIYRMFUKciUHVNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_9083523c8f14dc9ea712881f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "1206 Barker Cypress Rd, Houston, TX 77094, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-dd96-740a-beb3-5c0905e731af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-dd96-740a-beb3-5c0905e731af",
        "storage_key": "property/6300377863421952/019f1505-dd96-740a-beb3-5c0905e731af.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/houston/1206-barker-cypress-rd-41305?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9242400988125388260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "29.785917",
      "poi_longitude": "-95.687734",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 346-400-3412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3e95-706e-9a98-e502b2ecb9b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3e95-706e-9a98-e502b2ecb9b3",
        "storage_key": "property/6300377863421952/019f1506-3e95-706e-9a98-e502b2ecb9b3.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJexhMIuvZQIYR5N3u-LqaQ4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_32ed0f78ea27e7ef0150fab7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "JS Mart #3",
      "poi_type": "Shopping & Retail",
      "poi_address": "5418 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-df2e-7609-9fe7-9055ed900f06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-df2e-7609-9fe7-9055ed900f06",
        "storage_key": "property/6300377863421952/019f1505-df2e-7609-9fe7-9055ed900f06.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11255948664523949581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "js-mart-3",
      "poi_latitude": "29.8530817",
      "poi_longitude": "-95.682945",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-861-4673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3e95-706e-9a98-e502b2ecb9b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3e95-706e-9a98-e502b2ecb9b3",
        "storage_key": "property/6300377863421952/019f1506-3e95-706e-9a98-e502b2ecb9b3.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ4ZLn9hLXQIYRDYb7fqwpNZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_32def83c56db50d2f2d8f009",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "La Michoacana Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "3700 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "Mexican supermarket with meat, grocery & bakery departments, plus beers & an on-site taqueria.",
      "poi_long_description": "Mexican supermarket with meat, grocery & bakery departments, plus beers & an on-site taqueria.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-df83-73ee-81e7-2cdca7afc30f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-df83-73ee-81e7-2cdca7afc30f",
        "storage_key": "property/6300377863421952/019f1505-df83-73ee-81e7-2cdca7afc30f.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "http://elahorro.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8328663748504161321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-michoacana-supermarket",
      "poi_latitude": "29.823651",
      "poi_longitude": "-95.6860848",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-579-9443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f4-726e-b709-e758cbb98195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f4-726e-b709-e758cbb98195",
        "storage_key": "property/6300377863421952/019f1503-a0f4-726e-b709-e758cbb98195.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9N_R2_ZQIYRKYxDV41blXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_f4fc0ce6cc51b177c1fd055c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "18030 FM 529, Cypress, TX 77433, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e002-7429-9c5f-2832226b5e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e002-7429-9c5f-2832226b5e89",
        "storage_key": "property/6300377863421952/019f1505-e002-7429-9c5f-2832226b5e89.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/cypress/barker-cypress/034/00352?cid=loc_03400352_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14854923796221696316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.8814162",
      "poi_longitude": "-95.6855884",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-550-9493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f4-726e-b709-e758cbb98195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f4-726e-b709-e758cbb98195",
        "storage_key": "property/6300377863421952/019f1503-a0f4-726e-b709-e758cbb98195.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TWPeAnXQIYRPJlK53xKJ84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_dca8d2daf7e792ab9481e296",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11425 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Chain grocery outlet selling a variety of products, including electronics and furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e210-74d3-8bf0-7c4add7adb78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e210-74d3-8bf0-7c4add7adb78",
        "storage_key": "property/6300377863421952/019f1505-e210-74d3-8bf0-7c4add7adb78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/4465-cypress-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14181600095972179897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "29.9422157",
      "poi_longitude": "-95.6806339",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 832-349-7190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f4-726e-b709-e758cbb98195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f4-726e-b709-e758cbb98195",
        "storage_key": "property/6300377863421952/019f1503-a0f4-726e-b709-e758cbb98195.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUFrC4PWQIYRuT8RYyYqz8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_1d7a0749cf05ca1595f164df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "4007 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e1ab-7300-999e-dd913132fe6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e1ab-7300-999e-dd913132fe6b",
        "storage_key": "property/6300377863421952/019f1505-e1ab-7300-999e-dd913132fe6b.webp",
        "width": 611,
        "height": 456
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4007+barker+cypress+rd-houston-tx-77084/id=6909",
      "poi_directions_map_url": "https://maps.google.com/?cid=6092778724756165491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.8316582",
      "poi_longitude": "-95.6855026",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-550-9804",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD2MQGnbZQIYRcxMmIPjljVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_dcfabfe9ca51a6170f6f0ee1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "8960 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e207-742f-886e-7a633ca9f1c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e207-742f-886e-7a633ca9f1c7",
        "storage_key": "property/6300377863421952/019f1505-e207-742f-886e-7a633ca9f1c7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/cypress-tx-pharmacies/8960-barker-cypress-rd-cypress-tx-77433/storeid=5839?WT.mc_id=LS_GOOGLE_FS_5839",
      "poi_directions_map_url": "https://maps.google.com/?cid=4450427042305214807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.9080618",
      "poi_longitude": "-95.6851606",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-656-3520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCz-7SvjWQIYRVwlly9AXwz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_f77d91f9960f9d730cbdc0f8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Circle A Food Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "11302 Huffmeister Rd, Houston, TX 77065, USA",
      "poi_short_description": "Quick-visit convenience store and gas station.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14223768423103540418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-a-food-store",
      "poi_latitude": "29.9390793",
      "poi_longitude": "-95.628442",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 281-469-5677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3e95-706e-9a98-e502b2ecb9b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3e95-706e-9a98-e502b2ecb9b3",
        "storage_key": "property/6300377863421952/019f1506-3e95-706e-9a98-e502b2ecb9b3.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJhUFLRFzRQIYRwiyBIgX6ZMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_b1bfcee0ca41a0cfce50a14e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Barker Cypress Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "1855 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6117442791572290408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barker-cypress-plaza",
      "poi_latitude": "29.7956151",
      "poi_longitude": "-95.6891069",
      "poi_miles_from_property": "200 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a149-7483-85d3-d83cebb2c9ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a149-7483-85d3-d83cebb2c9ce",
        "storage_key": "property/6300377863421952/019f1503-a149-7483-85d3-d83cebb2c9ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWa_1cArZQIYRaLtwrc6F5VQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_0b5226ba72b4f2c5a0c1fac9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Mayde Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "2698 Greenhouse Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e382-7649-b816-a7ba6f3d6c37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e382-7649-b816-a7ba6f3d6c37",
        "storage_key": "property/6300377863421952/019f1505-e382-7649-b816-a7ba6f3d6c37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.katyisd.org/MCE",
      "poi_directions_map_url": "https://maps.google.com/?cid=2590925314768944224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayde-creek-elementary-school",
      "poi_latitude": "29.8056828",
      "poi_longitude": "-95.7027889",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-237-3950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ4O1_PXYQIYRYLxestjQ9CM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_9991612d74b0b415d6a254a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Mayde Creek Junior High",
      "poi_type": "Education",
      "poi_address": "2700 Greenhouse Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.katyisd.org/MCJH",
      "poi_directions_map_url": "https://maps.google.com/?cid=3285342214129354252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayde-creek-junior-high",
      "poi_latitude": "29.8073448",
      "poi_longitude": "-95.7031799",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-237-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0Ty2_PXYQIYRDIbGVlbhly0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_49c9591e52102fd5ede4d3ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Mayde Creek High School",
      "poi_type": "Education",
      "poi_address": "19202 Groschke Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e710-7515-9b10-0acfec674dc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e710-7515-9b10-0acfec674dc3",
        "storage_key": "property/6300377863421952/019f1505-e710-7515-9b10-0acfec674dc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mchs.katyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13483098442281929966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayde-creek-high-school",
      "poi_latitude": "29.8063302",
      "poi_longitude": "-95.6947646",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-237-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc-KoNlbYQIYR7kzWw5iWHbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_21f043605bcf314b0fc4f19a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "The Goddard School of Houston - Barker Cypress",
      "poi_type": "Education",
      "poi_address": "3655 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "Bright preschool and after-school center featuring classrooms and a playground, with teachers and staff who encourage learning.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e6fd-75fe-8d12-9aaa3086a135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e6fd-75fe-8d12-9aaa3086a135",
        "storage_key": "property/6300377863421952/019f1505-e6fd-75fe-8d12-9aaa3086a135.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/tx/houston/houston-barker-cypress?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=11987763435822198942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-houston---barker-cypress",
      "poi_latitude": "29.8215347",
      "poi_longitude": "-95.6873466",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-819-6750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb9GEXLPZQIYRnjCZu1QXXaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_013b2caa3eac171cecde56ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Exploring Minds Learning Center LLC",
      "poi_type": "Education",
      "poi_address": "5211 Barker Cypress Rd Suite 120, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e83b-720b-b252-b6ca42e706eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e83b-720b-b252-b6ca42e706eb",
        "storage_key": "property/6300377863421952/019f1505-e83b-720b-b252-b6ca42e706eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.exploringmindslearningcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1605093985416544256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exploring-minds-learning-center-llc",
      "poi_latitude": "29.8500764",
      "poi_longitude": "-95.6837848",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-674-8110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPVQyyNXZQIYRAIDev3lwRhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_92c112390f362fb0a9ee299b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Growing Minds Academy & Daycare",
      "poi_type": "Education",
      "poi_address": "6955 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e7d7-74fa-8736-7f01ded76256.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e7d7-74fa-8736-7f01ded76256",
        "storage_key": "property/6300377863421952/019f1505-e7d7-74fa-8736-7f01ded76256.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://growingmindsacademy.infiniteleadsaitechnology.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5430817238637545631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "growing-minds-academy--daycare",
      "poi_latitude": "29.8785304",
      "poi_longitude": "-95.6837194",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 832-742-1932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcWm0zbXXQIYRnwgPPYEjXks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_831046b21f4e13c4aff922d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Harmony School of Discovery Houston",
      "poi_type": "Education",
      "poi_address": "6270 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ecef-726a-927a-e66fa1ee4643.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ecef-726a-927a-e66fa1ee4643",
        "storage_key": "property/6300377863421952/019f1505-ecef-726a-927a-e66fa1ee4643.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://hsdhouston.harmonytx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1802679611241553038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harmony-school-of-discovery-houston",
      "poi_latitude": "29.8633886",
      "poi_longitude": "-95.6822786",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-861-5105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyR6NKHfXQIYRjlzkL45nBBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_5020dd369c25e4f634df6e3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Lycée International de Houston - LIH",
      "poi_type": "Education",
      "poi_address": "15950 Park Row Blvd Ste.A, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ea8b-71ea-9022-c417cc357cc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ea8b-71ea-9022-c417cc357cc8",
        "storage_key": "property/6300377863421952/019f1505-ea8b-71ea-9022-c417cc357cc8.webp",
        "width": 1280,
        "height": 612
      },
      "poi_business_url": "https://www.lihouston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3481477405101064279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lyce-international-de-houston---lih",
      "poi_latitude": "29.7890692",
      "poi_longitude": "-95.6618742",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-474-1013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn4iXq27ZQIYRVwCZGEGxUDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_20b4879d851eb9683a0b4a19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "British International School of Houston",
      "poi_type": "Education",
      "poi_address": "2203 N Westgreen Blvd, Katy, TX 77449, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-e8a2-767e-87df-d327bf1bb1eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-e8a2-767e-87df-d327bf1bb1eb",
        "storage_key": "property/6300377863421952/019f1505-e8a2-767e-87df-d327bf1bb1eb.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.nordangliaeducation.com/bis-houston?utm_source=google&utm_medium=organic&utm_campaign=Yext_GBM_AM010_10700937&y_source=1_MTA3MDA5MzctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15064192478506077171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "british-international-school-of-houston",
      "poi_latitude": "29.7994057",
      "poi_longitude": "-95.7370579",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-290-9025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7ybf_mjGQIYR80t35T7DDtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_731ead09abe21995b0c73194",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Lone Star College-CyFair",
      "poi_type": "Education",
      "poi_address": "9191 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Store for university course materials, computer supplies & apparel, plus textbooks & other titles.",
      "poi_long_description": "Store for university course materials, computer supplies & apparel, plus textbooks & other titles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ec20-70d8-aa90-4cfe9b5e7956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ec20-70d8-aa90-4cfe9b5e7956",
        "storage_key": "property/6300377863421952/019f1505-ec20-70d8-aa90-4cfe9b5e7956.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.lonestar.edu/cyfair",
      "poi_directions_map_url": "https://maps.google.com/?cid=13135137973791093682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-cyfair",
      "poi_latitude": "29.9113888",
      "poi_longitude": "-95.6926131",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-290-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsfxWwFnWQIYRsvOP62RiSbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_a6ee4c3494d91244f334f2ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Berry Center of Northwest Houston",
      "poi_type": "Entertainment",
      "poi_address": "8877 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Massive venue hosting a range of events including graduations, conventions & career fairs.",
      "poi_long_description": "Massive venue hosting a range of events including graduations, conventions & career fairs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ec82-716e-bae8-1dc9578c38ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ec82-716e-bae8-1dc9578c38ce",
        "storage_key": "property/6300377863421952/019f1505-ec82-716e-bae8-1dc9578c38ce.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://berrycenter.cfisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2743830810310065637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "berry-center-of-northwest-houston",
      "poi_latitude": "29.90495",
      "poi_longitude": "-95.6884875",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-894-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRJ_oPjWQIYR5b1NpJULFCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_d57cadebe1c8a4e3917e4eb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "The Boardwalk at Towne Lake",
      "poi_type": "Entertainment",
      "poi_address": "9955 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Family-friendly shopping center and boardwalk with a selection of restaurants, some dating to the 1900s.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ece9-704c-ae58-a711fa810c77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ece9-704c-ae58-a711fa810c77",
        "storage_key": "property/6300377863421952/019f1505-ece9-704c-ae58-a711fa810c77.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.boardwalktl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11033819634413638206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boardwalk-at-towne-lake",
      "poi_latitude": "29.9221669",
      "poi_longitude": "-95.6880238",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 713-690-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a149-7483-85d3-d83cebb2c9ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a149-7483-85d3-d83cebb2c9ce",
        "storage_key": "property/6300377863421952/019f1503-a149-7483-85d3-d83cebb2c9ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjwpVp4rWQIYRPpL0cH8AIJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_e09208a76e63d9c6a9755af4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Star Cinema Grill",
      "poi_type": "Entertainment",
      "poi_address": "8920 Fry Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Movie theater with a full restaurant, stadium seating, and reclining seats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-f3e3-738b-8ecd-7991c0388cc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-f3e3-738b-8ecd-7991c0388cc5",
        "storage_key": "property/6300377863421952/019f1505-f3e3-738b-8ecd-7991c0388cc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/cypress",
      "poi_directions_map_url": "https://maps.google.com/?cid=7889952193239806596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill",
      "poi_latitude": "29.9115998",
      "poi_longitude": "-95.7245619",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 832-497-5140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3ef1-760e-8494-748722742199.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3ef1-760e-8494-748722742199",
        "storage_key": "property/6300377863421952/019f1506-3ef1-760e-8494-748722742199.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJw52s7SbWQIYRhHLfjLe9fm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_062ea14614f8cc5d942e3222",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Cinemark Cypress and XD",
      "poi_type": "Entertainment",
      "poi_address": "25720 Northwest Fwy, Cypress, TX 77429, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-f070-76cc-90b4-8c73a4bba1ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-f070-76cc-90b4-8c73a4bba1ce",
        "storage_key": "property/6300377863421952/019f1505-f070-76cc-90b4-8c73a4bba1ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-cypress/cinemark-cypress-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=1450943990742131491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-cypress-and-xd",
      "poi_latitude": "29.9700743",
      "poi_longitude": "-95.6885768",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 48 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 281-256-7652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3ef1-760e-8494-748722742199.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3ef1-760e-8494-748722742199",
        "storage_key": "property/6300377863421952/019f1506-3ef1-760e-8494-748722742199.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJL1syDrjVQIYRIyMsRd_JIhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_980965bbe0b5217e731bec3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "The Daly Round Sports Bar + Indoor Golf",
      "poi_type": "Entertainment",
      "poi_address": "11734 Barker Cypress Rd #116, Cypress, TX 77433, USA",
      "poi_short_description": "Relaxed indoor golf venue with simulators, TVs and a bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-f0c4-73c8-97dd-31783002c8ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-f0c4-73c8-97dd-31783002c8ea",
        "storage_key": "property/6300377863421952/019f1505-f0c4-73c8-97dd-31783002c8ea.webp",
        "width": 1280,
        "height": 945
      },
      "poi_business_url": "http://www.thedalyround.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1901999887476017187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-daly-round-sports-bar--indoor-golf",
      "poi_latitude": "29.9454952",
      "poi_longitude": "-95.6756431",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 346-462-7043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3e98-7029-81fd-3fb847aa589e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3e98-7029-81fd-3fb847aa589e",
        "storage_key": "property/6300377863421952/019f1506-3e98-7029-81fd-3fb847aa589e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc8FFMy7VQIYRI0jXB9JCZRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_003a6acbc9bcd3e47f37ff3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Bounce Bounce",
      "poi_type": "Entertainment",
      "poi_address": "7955 Barker Cypress Rd Ste 100, Cypress, TX 77433, USA",
      "poi_short_description": "Play center for adults & kids with colorful mats & jumping surfaces, a foam pit & exercise classes.",
      "poi_long_description": "Play center for adults & kids with colorful mats & jumping surfaces, a foam pit & exercise classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-f393-75ae-99f1-ae69975027c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-f393-75ae-99f1-ae69975027c4",
        "storage_key": "property/6300377863421952/019f1505-f393-75ae-99f1-ae69975027c4.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://bouncebouncepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17999826601174283694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bounce-bounce",
      "poi_latitude": "29.8927282",
      "poi_longitude": "-95.6845395",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-246-4460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZhzTAHXQIYRrrWeNe06zPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_f013a3f7edbe38258928f593",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Harris County Deputy Darren Goforth Park on Horsepen Creek",
      "poi_type": "Entertainment",
      "poi_address": "9118 Wheat Cross Dr, Houston, TX 77095, USA",
      "poi_short_description": "Park featuring a lake, fishing, a playground, a rope climb, a dog park, trails & restrooms.",
      "poi_long_description": "Park featuring a lake, fishing, a playground, a rope climb, a dog park, trails & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-fa26-7506-933b-a7a8601904bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-fa26-7506-933b-a7a8601904bd",
        "storage_key": "property/6300377863421952/019f1505-fa26-7506-933b-a7a8601904bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pct3.com/Explore/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12443433877170096150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-county-deputy-darren-goforth-park-on-horsepen-creek",
      "poi_latitude": "29.9102818",
      "poi_longitude": "-95.6794716",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 713-274-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3X7xfvrWQIYRFgjJ4i71r6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f2f94ff7ee011415c924b302",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Houston Premium Outlets",
      "poi_type": "Entertainment",
      "poi_address": "29300 Hempstead Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Off-retail designer outposts selling women's & men's premium apparel, shoes, gifts & accessories.",
      "poi_long_description": "Off-retail designer outposts selling women's & men's premium apparel, shoes, gifts & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-f629-7253-ba89-d21f0024eba2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-f629-7253-ba89-d21f0024eba2",
        "storage_key": "property/6300377863421952/019f1505-f629-7253-ba89-d21f0024eba2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/houston",
      "poi_directions_map_url": "https://maps.google.com/?cid=15337986639342905116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-premium-outlets",
      "poi_latitude": "29.9967906",
      "poi_longitude": "-95.7567342",
      "poi_miles_from_property": "21.0 mi",
      "poi_walking_minutes": "7 hours 45 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 281-304-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a149-7483-85d3-d83cebb2c9ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a149-7483-85d3-d83cebb2c9ce",
        "storage_key": "property/6300377863421952/019f1503-a149-7483-85d3-d83cebb2c9ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOxM7lrnVQIYRHKe4l5V529Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_40efcdbad220e3482aceae3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Typhoon Texas Waterpark Houston",
      "poi_type": "Entertainment",
      "poi_address": "555 Katy Fort Bend Rd, Katy, TX 77494, USA",
      "poi_short_description": "Spacious, playful place with serpentine water slides & a lazy river for tubing, plus eateries.",
      "poi_long_description": "Spacious, playful place with serpentine water slides & a lazy river for tubing, plus eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-f522-7182-94e8-057fbeb1cec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-f522-7182-94e8-057fbeb1cec2",
        "storage_key": "property/6300377863421952/019f1505-f522-7182-94e8-057fbeb1cec2.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.typhoontexas.com/houston",
      "poi_directions_map_url": "https://maps.google.com/?cid=17151496343800091588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "typhoon-texas-waterpark-houston",
      "poi_latitude": "29.7794714",
      "poi_longitude": "-95.8035959",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 832-426-7071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9qVvZcmQYYRxJOdWg1bBu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_a146d5e4c00613a4d4937777",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Escapology Escape Rooms Cypress",
      "poi_type": "Entertainment",
      "poi_address": "11970 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Players try to find clues, crack codes, and solve puzzles to escape themed rooms at this chain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-faf7-7388-a5ed-902afa207b8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-faf7-7388-a5ed-902afa207b8f",
        "storage_key": "property/6300377863421952/019f1505-faf7-7388-a5ed-902afa207b8f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.escapology.com/en/cypress-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12585994765133402290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "escapology-escape-rooms-cypress",
      "poi_latitude": "29.9497213",
      "poi_longitude": "-95.6737992",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 832-979-3858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJucusoujVQIYRstCzMI5vqq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_77a3feced9e202200ecce9f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Houston Methodist West Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "18500 Katy Fwy, Houston, TX 77094, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-6ef3-756c-bdb4-21ef39548975.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-6ef3-756c-bdb4-21ef39548975",
        "storage_key": "property/6300377863421952/019f1503-6ef3-756c-bdb4-21ef39548975.webp",
        "width": 1280,
        "height": 629
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/katy-west/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=9315019254502396471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-west-hospital",
      "poi_latitude": "29.7872016",
      "poi_longitude": "-95.6982542",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-522-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a105-703b-9237-d0210097c73e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a105-703b-9237-d0210097c73e",
        "storage_key": "property/6300377863421952/019f1503-a105-703b-9237-d0210097c73e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYUrEObYQIYRNxKKrKiYRYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_d98c09b51d18aa3aa02e9db5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Cypress",
      "poi_type": "Health and Wellness",
      "poi_address": "9110 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-fa15-75ab-bb31-93048ce5da7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-fa15-75ab-bb31-93048ce5da7b",
        "storage_key": "property/6300377863421952/019f1505-fa15-75ab-bb31-93048ce5da7b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/houston/cypress?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4910752433881606480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---cypress",
      "poi_latitude": "29.91016609999999",
      "poi_longitude": "-95.6855208",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-746-4944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT_fRETDXQIYRUOllAVJ_JkQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_6f3ba79c9a9478fbb1646237",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Village Medical at Walgreens - Bear Creek",
      "poi_type": "Health and Wellness",
      "poi_address": "4005 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-fb67-7559-b44c-03687a3c8e6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-fb67-7559-b44c-03687a3c8e6f",
        "storage_key": "property/6300377863421952/019f1505-fb67-7559-b44c-03687a3c8e6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.villagemedical.com/locations/texas/4005-barker-cypress-rd-houston-tx-77084?utm_source=gmb&utm_medium=profile&utm_campaign=villagemedical_organic-search_location",
      "poi_directions_map_url": "https://maps.google.com/?cid=15572146147252784075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-medical-at-walgreens---bear-creek",
      "poi_latitude": "29.8315189",
      "poi_longitude": "-95.6855675",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 346-235-1975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8ZPT_TZQIYRy0t4iWpgG9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_8fde80779f153f0d6b49fe45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4007 Barker Cypress Rd, Houston, TX 77084, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-fe1d-7293-bf6c-3fd122722d46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-fe1d-7293-bf6c-3fd122722d46",
        "storage_key": "property/6300377863421952/019f1505-fe1d-7293-bf6c-3fd122722d46.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4007+barker+cypress+rd-houston-tx-77084/id=6909",
      "poi_directions_map_url": "https://maps.google.com/?cid=1740610541562744295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.8316442",
      "poi_longitude": "-95.6854895",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-550-9804",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-c0a2fa567747.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-c0a2fa567747",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-c0a2fa567747.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEw0c_srZQIYR580lvhDkJxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_8837de4a1eff7fd5abea8aba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6079 Hwy 6 N, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-fcd6-752b-b569-fc3709a5fd72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-fcd6-752b-b569-fc3709a5fd72",
        "storage_key": "property/6300377863421952/019f1505-fcd6-752b-b569-fc3709a5fd72.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/6079-hwy-6-n-houston-tx-77084/storeid=3178?WT.mc_id=LS_GOOGLE_RX_3178",
      "poi_directions_map_url": "https://maps.google.com/?cid=3154472437154458273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.8671767",
      "poi_longitude": "-95.6459183",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-855-5461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-c0a2fa567747.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-c0a2fa567747",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-c0a2fa567747.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ___vMk3XQIYRoSpa7vfvxis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c8e58eed39fb20b247f39b87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4955 Hwy 6 N, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ffae-75f8-b890-a8b86e5cdd83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ffae-75f8-b890-a8b86e5cdd83",
        "storage_key": "property/6300377863421952/019f1505-ffae-75f8-b890-a8b86e5cdd83.webp",
        "width": 1280,
        "height": 827
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=6065458397870578420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.84739399999999",
      "poi_longitude": "-95.64758",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-463-9148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-c0a2fa567747.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-c0a2fa567747",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-c0a2fa567747.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVeC4AODlQIYR9Fr81EbWLFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a8569ba21935342a5229c9bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12304 Barker Cypress Rd, Cypress, TX 77429, USA",
      "poi_short_description": "Chain fitness center offering cardio and strength equipment plus a pool and sauna, as well as racquetball and basketball courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ffab-7398-8723-cb892bebd8e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ffab-7398-8723-cb892bebd8e3",
        "storage_key": "property/6300377863421952/019f1505-ffab-7398-8723-cb892bebd8e3.webp",
        "width": 864,
        "height": 863
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=327&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16682658190693225654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "29.95440379999999",
      "poi_longitude": "-95.6692962",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 281-304-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzLFqSTUQIYRttSHZTy1hOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f6eb2f16be6d20b12802347c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9925 Barker Cypress Rd #143, Cypress, TX 77433, USA",
      "poi_short_description": "Chain fitness center offering full-body workouts with cardio and strength training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-04af-769c-9003-101d13779391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-04af-769c-9003-101d13779391",
        "storage_key": "property/6300377863421952/019f1506-04af-769c-9003-101d13779391.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/cypress-texas-0405?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=13488544697805391941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "29.9215022",
      "poi_longitude": "-95.6878325",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-661-1006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh46GsorWQIYRRUir8e_vMLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_588c3abae64468ad26bc8ece",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "9922 Fry Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Large, clean athletic club featuring a fitness floor and a relaxation area with a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-01ae-709d-aceb-06b19dc6d125.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-01ae-709d-aceb-06b19dc6d125",
        "storage_key": "property/6300377863421952/019f1506-01ae-709d-aceb-06b19dc6d125.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/cypress.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=14319491524084473536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "29.9304946",
      "poi_longitude": "-95.7266667",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 832-745-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVQni7RzWQIYRwJ5FWawNucY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0500df19998364d77e645c84",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Randalls Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "18322 Clay Rd, Houston, TX 77084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0283-75fe-bed0-9a6e46135c47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0283-75fe-bed0-9a6e46135c47",
        "storage_key": "property/6300377863421952/019f1506-0283-75fe-bed0-9a6e46135c47.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://local.pharmacy.randalls.com/tx/houston/18322-clay-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5217726789603429459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randalls-pharmacy",
      "poi_latitude": "29.8327035",
      "poi_longitude": "-95.6837042",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-858-9026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-c0a2fa567747.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-c0a2fa567747",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-c0a2fa567747.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-bMx8vZQIYRUwxa1d4WaUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c1e7a230714608392d20c856",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Cullen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19008 Saums Rd, Houston, TX 77084, USA",
      "poi_short_description": "Park & recreational land adjacent to a reservoir with walking/biking trails, ball fields & more.",
      "poi_long_description": "Park & recreational land adjacent to a reservoir with walking/biking trails, ball fields & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-753c-7266-9cc1-f473dedf006a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-753c-7266-9cc1-f473dedf006a",
        "storage_key": "property/6300377863421952/019f1503-753c-7266-9cc1-f473dedf006a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstontx.gov/parks/waterspraygrounds.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13091954992662904952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cullen-park",
      "poi_latitude": "29.8008996",
      "poi_longitude": "-95.6949814",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyd0zKDZQIYReAATobP3r7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_63466908b78ec89702e70e15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Deputy Darren Goforth Park on Horsepen Creek",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9402 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Spacious dog park on the shore of a lake, featuring an agility course, walking trails, benches and wash stations.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0392-75ba-a95b-c260a230f9d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0392-75ba-a95b-c260a230f9d6",
        "storage_key": "property/6300377863421952/019f1506-0392-75ba-a95b-c260a230f9d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3889359748452366808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deputy-darren-goforth-park-on-horsepen-creek",
      "poi_latitude": "29.9132581",
      "poi_longitude": "-95.6805887",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmwAEa_HWQIYR2Lk0ohXI-TU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_ced0799049bebc4414fbe4e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Bear Creek Pioneers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3535 War Memorial St, Houston, TX 77084, USA",
      "poi_short_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_long_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-7e38-76cd-8a2b-3d89efc071a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-7e38-76cd-8a2b-3d89efc071a9",
        "storage_key": "property/6300377863421952/019f1503-7e38-76cd-8a2b-3d89efc071a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15025692315525117298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-pioneers-park",
      "poi_latitude": "29.8252332",
      "poi_longitude": "-95.6270195",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwGbtFzaQIYRcvUwK437hdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b232b5c21e0fbc87481fcac8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "The Boardwalk at Towne Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9955 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Family-friendly shopping center and boardwalk with a selection of restaurants, some dating to the 1900s.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ece9-704c-ae58-a711fa810c77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ece9-704c-ae58-a711fa810c77",
        "storage_key": "property/6300377863421952/019f1505-ece9-704c-ae58-a711fa810c77.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.boardwalktl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11033819634413638206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boardwalk-at-towne-lake",
      "poi_latitude": "29.9221669",
      "poi_longitude": "-95.6880238",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 713-690-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a149-7483-85d3-d83cebb2c9ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a149-7483-85d3-d83cebb2c9ce",
        "storage_key": "property/6300377863421952/019f1503-a149-7483-85d3-d83cebb2c9ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjwpVp4rWQIYRPpL0cH8AIJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_88139282fe69c36f150d9386",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Russ Poppe Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11675 Grant Rd, Houston, TX 77070, USA",
      "poi_short_description": "Relaxed playground and park featuring an array of activities ranging from biking and pickleball to dog-walking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0f29-77b7-8da9-4d640827a15a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0f29-77b7-8da9-4d640827a15a",
        "storage_key": "property/6300377863421952/019f1506-0f29-77b7-8da9-4d640827a15a.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.pct3.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1025405581500811624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russ-poppe-family-park",
      "poi_latitude": "29.9725771",
      "poi_longitude": "-95.599476",
      "poi_miles_from_property": "16.7 mi",
      "poi_walking_minutes": "6 hours 8 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYkZGDXTQIYRaAkPjPH4Og4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_530e17ac982eab46ebbbafca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Legacy at Cypress",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11111 Grant Rd, Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0da3-7504-9b5f-5c0a7271e3c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0da3-7504-9b5f-5c0a7271e3c9",
        "storage_key": "property/6300377863421952/019f1506-0da3-7504-9b5f-5c0a7271e3c9.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://www.legacyatcypressapts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16783367693754234409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-at-cypress",
      "poi_latitude": "29.9664248",
      "poi_longitude": "-95.5887674",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 38 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 866-580-4347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2fLRTnSQIYRKfb80P5_6ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_f12d364622887ad4809273bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Maxwell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12622 Maxwell Rd, Cypress, TX 77429, USA",
      "poi_short_description": "Natural park featuring walking trails, picnic tables, and access to White Oak Bayou.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-06c2-7359-aa5f-f5af39beb203.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-06c2-7359-aa5f-f5af39beb203",
        "storage_key": "property/6300377863421952/019f1506-06c2-7359-aa5f-f5af39beb203.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pct3.com/parks/#maxwell-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9965902868248794332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maxwell-park",
      "poi_latitude": "29.9650071",
      "poi_longitude": "-95.6215829",
      "poi_miles_from_property": "15.3 mi",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 281-496-2177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmTqHSMHTQIYR3BQEaNv_TYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5eadf3fb0762ebc31db83df0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "George Bush Park Bike Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16756 Westheimer Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "Family-friendly park with scenic views and a long trail for walking, biking or running.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0b4e-7056-aabd-39c6f36fc376.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0b4e-7056-aabd-39c6f36fc376",
        "storage_key": "property/6300377863421952/019f1506-0b4e-7056-aabd-39c6f36fc376.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=469630594180836084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-park-bike-trail",
      "poi_latitude": "29.7236788",
      "poi_longitude": "-95.6875102",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9-5hIuDeQIYR9OrNhYl2hAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a3a02697faaa29592e578272",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Kickerillo-Mischer Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20215 Chasewood Park Dr, Houston, TX 77070, USA",
      "poi_short_description": "This 80-acre preserve features Marshall Lake, fishing piers, a canoe launch, paved trails & more.",
      "poi_long_description": "This 80-acre preserve features Marshall Lake, fishing piers, a canoe launch, paved trails & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0914-765d-8e37-c415aeb4541c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0914-765d-8e37-c415aeb4541c",
        "storage_key": "property/6300377863421952/019f1506-0914-765d-8e37-c415aeb4541c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6601753626346515604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kickerillo-mischer-preserve",
      "poi_latitude": "29.9880604",
      "poi_longitude": "-95.5707369",
      "poi_miles_from_property": "19.2 mi",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 713-274-4299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgeqkZHvSQIYRlOwHEfIjnls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_cafe00c2b1136fffe8c9db75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Water Haven Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lakeland Haven Dr, Cypress, TX 77433, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0d99-7417-ad85-2ad74273c092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0d99-7417-ad85-2ad74273c092",
        "storage_key": "property/6300377863421952/019f1506-0d99-7417-ad85-2ad74273c092.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13728974255834796369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "water-haven-park",
      "poi_latitude": "29.9555422",
      "poi_longitude": "-95.7512121",
      "poi_miles_from_property": "14.1 mi",
      "poi_walking_minutes": "5 hours 10 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a1b8-770a-9d86-2af6f73d1d68",
        "storage_key": "property/6300377863421952/019f1503-a1b8-770a-9d86-2af6f73d1d68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVfj0qQYYRURGEsVgdh74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7dd6785c95cda12a1af0ae0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Cypress Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "25210 US-290 Frontage Rd., Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0aa1-7309-95e2-2a19b25717f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0aa1-7309-95e2-2a19b25717f7",
        "storage_key": "property/6300377863421952/019f1506-0aa1-7309-95e2-2a19b25717f7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8813123989977222512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-park--ride",
      "poi_latitude": "29.9641577",
      "poi_longitude": "-95.6855147",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 43 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-bd2a934380d4",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39ayTa3RQIYRcM0QMJOBTno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_87be1bf807f9159f894b27cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Kingsland Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "21669 Kingsland Blvd, Katy, TX 77450, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-13df-764a-ae91-15c0bfd3d243.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-13df-764a-ae91-15c0bfd3d243",
        "storage_key": "property/6300377863421952/019f1506-13df-764a-ae91-15c0bfd3d243.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16228968268042078283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kingsland-park--ride",
      "poi_latitude": "29.7747945",
      "poi_longitude": "-95.7449571",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-bd2a934380d4",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJfz3tbkQnQYYRSwi8r6fgOOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_37ce07c65e58201bb6dcd283",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Grand Parkway Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1030 N Grand Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-21f9-702d-8519-5791ff4c8a24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-21f9-702d-8519-5791ff4c8a24",
        "storage_key": "property/6300377863421952/019f1506-21f9-702d-8519-5791ff4c8a24.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4263015384683988709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-parkway-park--ride",
      "poi_latitude": "29.7876219",
      "poi_longitude": "-95.7760204",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-bd2a934380d4",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-7oUuImQYYR5UYd7OdFKTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_66e7e70b302a7e12a136a7f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Addicks Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "14230 Old Katy Rd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-1f9e-755f-98ae-5a8bc2393cf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1f9e-755f-98ae-5a8bc2393cf7",
        "storage_key": "property/6300377863421952/019f1506-1f9e-755f-98ae-5a8bc2393cf7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6059542481948761620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "addicks-park--ride",
      "poi_latitude": "29.7872884",
      "poi_longitude": "-95.6383329",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-bd2a934380d4",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xDFp93bQIYRFN7xUcjRF1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_87dc5f6f81c63e69105bc07d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Northwest Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7373 Old Katy Rd, Houston, TX 77024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-1af2-765e-80a3-02cbbb6116c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-1af2-765e-80a3-02cbbb6116c0",
        "storage_key": "property/6300377863421952/019f1506-1af2-765e-80a3-02cbbb6116c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridemetro.org/pages/TC-Northwest.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887889931563584101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-transit-center",
      "poi_latitude": "29.7833768",
      "poi_longitude": "-95.4545941",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 30 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3DSrsfGQIYRZUoO4P5F1UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_bae29e4d34c4b9546936ef83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Cypress Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "25210 US-290 Frontage Rd., Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-0aa1-7309-95e2-2a19b25717f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-0aa1-7309-95e2-2a19b25717f7",
        "storage_key": "property/6300377863421952/019f1506-0aa1-7309-95e2-2a19b25717f7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8813123989977222512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-park--ride",
      "poi_latitude": "29.9641577",
      "poi_longitude": "-95.6855147",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 43 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1506-3eee-7293-a9ca-bd2a934380d4",
        "storage_key": "property/6300377863421952/019f1506-3eee-7293-a9ca-bd2a934380d4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39ayTa3RQIYRcM0QMJOBTno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_f2a80c9e3b0c3584de6a8d0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-2967-747f-8acb-0047e12f4af4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2967-747f-8acb-0047e12f4af4",
        "storage_key": "property/6300377863421952/019f1506-2967-747f-8acb-0047e12f4af4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "34.6 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "3 hours 1 min",
      "poi_driving_minutes": "42 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a102-73db-85b7-ba8dc490721a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a102-73db-85b7-ba8dc490721a",
        "storage_key": "property/6300377863421952/019f1503-a102-73db-85b7-ba8dc490721a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_b49a4d0b4234676a3ba476ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Lone Star College-CyFair",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9191 Barker Cypress Rd, Cypress, TX 77433, USA",
      "poi_short_description": "Store for university course materials, computer supplies & apparel, plus textbooks & other titles.",
      "poi_long_description": "Store for university course materials, computer supplies & apparel, plus textbooks & other titles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1505-ec20-70d8-aa90-4cfe9b5e7956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-ec20-70d8-aa90-4cfe9b5e7956",
        "storage_key": "property/6300377863421952/019f1505-ec20-70d8-aa90-4cfe9b5e7956.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.lonestar.edu/cyfair",
      "poi_directions_map_url": "https://maps.google.com/?cid=13135137973791093682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-cyfair",
      "poi_latitude": "29.9113888",
      "poi_longitude": "-95.6926131",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-290-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsfxWwFnWQIYRsvOP62RiSbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_330dd8bbfddce8e3540d50d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Houston Methodist Willowbrook Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18220 TX-249, Houston, TX 77070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-29d2-763d-b2b8-cae5073f4227.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-29d2-763d-b2b8-cae5073f4227",
        "storage_key": "property/6300377863421952/019f1506-29d2-763d-b2b8-cae5073f4227.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/willowbrook/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=10196221651682341886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-willowbrook-hospital",
      "poi_latitude": "29.967329",
      "poi_longitude": "-95.5504867",
      "poi_miles_from_property": "19.3 mi",
      "poi_walking_minutes": "7 hours 9 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 281-737-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a105-703b-9237-d0210097c73e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a105-703b-9237-d0210097c73e",
        "storage_key": "property/6300377863421952/019f1503-a105-703b-9237-d0210097c73e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49I-IO7NQIYR_jOs_5FBgI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_f0601691901fb8540eae0ab7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Memorial Hermann Cypress Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "27800 Northwest Fwy, Cypress, TX 77433, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-24bd-76aa-94a3-ccceacb6e79a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-24bd-76aa-94a3-ccceacb6e79a",
        "storage_key": "property/6300377863421952/019f1506-24bd-76aa-94a3-ccceacb6e79a.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/cypress/?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=2875916857937908689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-cypress-hospital",
      "poi_latitude": "29.9869462",
      "poi_longitude": "-95.7333276",
      "poi_miles_from_property": "19.5 mi",
      "poi_walking_minutes": "7 hours 11 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 346-231-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a105-703b-9237-d0210097c73e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a105-703b-9237-d0210097c73e",
        "storage_key": "property/6300377863421952/019f1503-a105-703b-9237-d0210097c73e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFREKC34qQYYR0VPyICVP6Sc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_80aca7f25d89d97ebe598a14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare North Cypress",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21214 Northwest Fwy, Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-2570-72f7-958c-064de6d2a0d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2570-72f7-958c-064de6d2a0d5",
        "storage_key": "property/6300377863421952/019f1506-2570-72f7-958c-064de6d2a0d5.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/north-cypress?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5610823420399779988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-north-cypress",
      "poi_latitude": "29.9260732",
      "poi_longitude": "-95.6311018",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 832-912-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a105-703b-9237-d0210097c73e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a105-703b-9237-d0210097c73e",
        "storage_key": "property/6300377863421952/019f1503-a105-703b-9237-d0210097c73e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-SuGEfRQIYRlABfZiym3U0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_8de4c18e3f86c6dff190b4d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Texas Children's Pediatrics Barker Cypress",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9925 Barker Cypress Rd #200, Cypress, TX 77433, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-2850-709e-bad7-10e5d7215011.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2850-709e-bad7-10e5d7215011",
        "storage_key": "property/6300377863421952/019f1506-2850-709e-bad7-10e5d7215011.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-pediatrics/barker-cypress",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897496910331537458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-pediatrics-barker-cypress",
      "poi_latitude": "29.9215022",
      "poi_longitude": "-95.6878325",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-890-6514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_soCEfRQIYRMmjKdoKKvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_71d0d15b020fdcb7a76ac6ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Cypress-Fairbanks Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11440 Matzke Rd, Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-325c-701b-b431-7e29a1a8903a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-325c-701b-b431-7e29a1a8903a",
        "storage_key": "property/6300377863421952/019f1506-325c-701b-b431-7e29a1a8903a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cfisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12821473923027533278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-fairbanks-independent-school-district",
      "poi_latitude": "29.9446056",
      "poi_longitude": "-95.6567325",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 281-897-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0fa-70e7-815d-82b56dd0ff96",
        "storage_key": "property/6300377863421952/019f1503-a0fa-70e7-815d-82b56dd0ff96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgQugn7_RQIYR3n39FpoG77E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_f55af771c199898bed0a0619",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "FedEx Ground",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8787 Grand Pkwy N, Cypress, TX 77433, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-2f55-758f-8314-924847974610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-2f55-758f-8314-924847974610",
        "storage_key": "property/6300377863421952/019f1506-2f55-758f-8314-924847974610.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fedex.com/en-us/shipping/ground.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3515234220261055916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fedex-ground",
      "poi_latitude": "29.9092777",
      "poi_longitude": "-95.7679396",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-463-3339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5lP8ajaQIYRrB31GOaeyDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "moving_company"
    },
    {
      "id": "ec_081ff207d3aef4fb76b8d150",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "Daikin Texas Technology Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19001 Kermier Rd, Waller, TX 77484, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-3021-709e-8bb3-017af79632a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-3021-709e-8bb3-017af79632a2",
        "storage_key": "property/6300377863421952/019f1506-3021-709e-8bb3-017af79632a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northamerica-daikin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13151938671965841163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daikin-texas-technology-park",
      "poi_latitude": "30.0493702",
      "poi_longitude": "-95.8595034",
      "poi_miles_from_property": "25.9 mi",
      "poi_walking_minutes": "9 hours 26 mins",
      "poi_biking_minutes": "2 hours 11 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 713-861-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJedMeht7SRoYRCyc_SooShbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_a26edfce74e8f3bdf8297dd2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "poi_name": "ExxonMobil Houston Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22777 Springwoods Village Pkwy, Spring, TX 77389, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1506-36a5-7178-a532-026bf024bc32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1506-36a5-7178-a532-026bf024bc32",
        "storage_key": "property/6300377863421952/019f1506-36a5-7178-a532-026bf024bc32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://corporate.exxonmobil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4652161626967610876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxonmobil-houston-campus",
      "poi_latitude": "30.1032818",
      "poi_longitude": "-95.4463252",
      "poi_miles_from_property": "32.2 mi",
      "poi_walking_minutes": "11 hours 51 mins",
      "poi_biking_minutes": "2 hours 46 mins",
      "poi_driving_minutes": "45 mins",
      "poi_business_phone": "+1 800-582-3645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-a0f5-753a-a4ee-4e379d763a9c",
        "storage_key": "property/6300377863421952/019f1503-a0f5-753a-a4ee-4e379d763a9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbXzI1A0R4YR_JUb_VnMj0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_dd7eab62-cd49-4f24-9aba-444868e937d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bf29b918-28d8-4f42-9cc6-8b96506e9a63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0abdcd0e-ac07-4706-b702-a0aa1898c26c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c0aa00a9-d07c-45b2-8364-41beca10e881",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_893c52f0-98ed-4763-93cb-f71ab669a2be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_e9f2f8f4-f8d6-4f64-9d73-da983b2863a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_0402a964-0431-4c76-a77f-47d941d764a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_95c71b7d-72e1-4b32-bf16-d492700002db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "rating": "5.0",
      "name": "Monica W",
      "text": "Momma Lt is one of the best leasing agents I’ve ever met. Throughout my moving process she was patient, enthusiastic, and supportive. The community has an amazing management and maintenance team, located in a safe area, with clean, beautiful and spacious homes. Thank you so much for everyone’s help Im glad to call this my new home 🩷 !!",
      "date": "2026-02-18",
      "title": ""
    },
    {
      "id": "custom_daf35322-907e-45fb-beb7-99883b29a825",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "rating": "5.0",
      "name": "Angela Zuniga",
      "text": "LaTonia is the most amazing human being ever! She has helped my family tremendously she is absolutely great with the open communication and guiding us on what we need to do and I remember telling her this place sounded to good to be true and let me tell you it is everything she says it is and more! The environment during our tour was warm and loving and I wanted to make sure I picked a home for my babies that felt safe and I felt that the minute I walked in. The Google Photos and website gallery of the complex is not a lie it all looks exactly like it. It’s beautiful and bright and very open. You see nothing but family’s and people with smiles and the front office is full of happy faces even if they aren’t the ones helping you. LaTonia has been so sweet and helpful and she will 100% tell you everything up front and not leave anything out so you don’t feel lost or misguided. I’ve talked to many apartments and there’s always something left out and here there isn’t. Very informative, communicative, and welcoming. So happy I get to have my family here and be apart of the lakefront family as well❤️",
      "date": "2026-05-16",
      "title": ""
    },
    {
      "id": "custom_5f6ad434-3ab6-4d5b-a340-9f96f5155245",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "rating": "5.0",
      "name": "Jeannuel Williams",
      "text": "I recently moved into my two-bedroom apartment at Lakefront Villas after relocating from out of state, and my experience has been great so far. Mama LT  💓 was sooooooo incredibly helpful in coordinating my move. She was thorough, responsive, supportive, and always patient, no matter how many questions I had (which were a lot)! She even went out of her way to help with a few things she didn’t have to, which really showed her kindness and dedication to the residents here.\nMeans a lot when you’re moving into a place.\n\nThe staff overall seem to genuinely care about supporting the community, which made my transition much smoother. I really love my apartment and the surrounding area, and I’m excited to continue settling in and making this place feel like home. 🤗",
      "date": "2026-04-06",
      "title": ""
    },
    {
      "id": "custom_63b76a0d-f76d-4caa-95e5-ad8f4b1940b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "rating": "5.0",
      "name": "ariel ahsan",
      "text": "Shout out to Miss LT and the Lakefront Villa team for helping get my family into a beautiful unit! We are enjoying the property immensely. Thank you for the care you all put into your work, we hope to stay for many years!",
      "date": "2026-04-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_a7008cac0501c969c8141ab3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f14c3-f137-71ac-9b40-15af581704d4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-f137-71ac-9b40-15af581704d4",
        "storage_key": "property/6300377863421952/019f14c3-f137-71ac-9b40-15af581704d4.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Lakefront Villas",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/dhunQbBP7q0"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-9d11-753d-92c5-5ca969a88140",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "lakefront-villas",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952"
    },
    {
      "lead_collector_id": "0198aa45-9d74-716d-834d-0ec2419fb27e",
      "lead_source": "FACEBOOK_ADS",
      "name": "lakefront-villas",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952"
    },
    {
      "lead_collector_id": "0198aa45-9dd6-721c-b3ee-fe109a9fa20a",
      "lead_source": "LANDING_PAGE",
      "name": "lakefront-villas",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-houston-tx",
      "search_query": "One Bedroom Apartments For Rent In Houston, TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In Houston, TX",
      "h2_subtitle": "Lakefront Villas offers serene living with stunning lakeside views. Experience the perfect blend of comfort and convenience in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where our one bedroom apartments for rent in Houston, TX, provide a peaceful retreat with sprawling green spaces and a community fishing lake. Located on Barker Cypress Road, our apartments feature sophisticated interiors and a range of amenities designed to enhance your lifestyle. Enjoy the resort-inspired pool, heated spa, and 24/7 fitness center, all set against the backdrop of a tranquil lakeside setting. Each apartment includes modern conveniences such as Wi-Fi, stainless steel appliances, and granite countertops, ensuring a comfortable and stylish living experience. Discover the perfect balance of nature and urban living at Lakefront Villas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | 1 Bedroom Apartments In Houston, TX",
      "seo_description": "Explore Lakefront Villas for one bedroom apartments for rent in Houston, TX. Enjoy lakeside views, modern amenities, and a serene community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-houston-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Houston, TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Houston, TX",
      "h2_subtitle": "Lakefront Villas provides a serene lakeside living experience. Enjoy spacious two-bedroom apartments with modern amenities in West Houston, Texas.",
      "page_copy": "At Lakefront Villas, our two bedrooms apartments for rent in Houston, TX, offer a perfect blend of comfort and style. Nestled in a community with sprawling green spaces and a tranquil lakeside gazebo, these apartments provide a peaceful retreat from the hustle and bustle of city life. Located on Barker Cypress Road, each apartment features modern interiors with amenities like Wi-Fi, stainless steel appliances, and granite countertops. Residents can enjoy community features such as a resort-inspired pool, heated spa, and a 24/7 fitness center. Experience the best of lakeside living with the convenience of urban amenities at Lakefront Villas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | 2 Bedrooms Apartments in Houston, TX",
      "seo_description": "Discover Lakefront Villas for two bedrooms apartments for rent in Houston, TX. Enjoy modern amenities and a serene lakeside community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-three-bedrooms-apartments-for-rent-houston-tx",
      "search_query": "Three Bedrooms Apartments For Rent In Houston, TX",
      "category": "Floorplan",
      "h1_title": "Find Three Bedrooms Apartments For Rent In Houston, TX",
      "h2_subtitle": "Lakefront Villas offers spacious three-bedroom apartments with lakeside views. Enjoy a serene community with modern amenities in West Houston, Texas.",
      "page_copy": "Discover the perfect family home at Lakefront Villas with our three bedrooms apartments for rent in Houston, TX. Situated amidst sprawling green spaces and a tranquil community fishing lake, these apartments provide a serene escape in West Houston. Located on Barker Cypress Road, each apartment is designed with sophisticated interiors and features like Wi-Fi, stainless steel appliances, and granite countertops. Residents can take advantage of community amenities such as a resort-inspired pool, heated spa, and a 24/7 fitness center. Experience the ideal blend of nature and modern living at Lakefront Villas, where comfort meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | 3 Bedrooms Apartments in Houston, TX",
      "seo_description": "Explore Lakefront Villas for three bedrooms apartments for rent in Houston, TX. Enjoy spacious living with modern amenities in a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent with Pool",
      "h2_subtitle": "Lakefront Villas offers a resort-inspired pool and serene lakeside living. Enjoy modern amenities and a tranquil setting in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent with pool access in a serene lakeside community. Located in West Houston, our community features a resort-inspired pool with a heated spa, perfect for relaxation and leisure. Our one, two, and three bedroom apartments on Barker Cypress Road offer sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a 24/7 fitness center, clubhouse, and pet play area. With sprawling green spaces and walking/biking trails, Lakefront Villas provides the perfect blend of nature and modern living. Experience the comfort and convenience of our idyllic community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments For Rent with Pool",
      "seo_description": "Explore Lakefront Villas for apartments for rent with pool access. Enjoy modern amenities and a serene lakeside community in West Houston, Texas.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Lakefront Villas offers a 24/7 fitness center and serene lakeside living. Enjoy modern amenities and a tranquil setting in West Houston, Texas.",
      "page_copy": "Discover Lakefront Villas, where you can find apartments for rent near me with fitness center access in a peaceful lakeside community. Located in West Houston, our community features a 24/7 fitness center, perfect for maintaining an active lifestyle. Our one, two, and three bedroom apartments on Barker Cypress Road offer sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, clubhouse, and pet play area. With sprawling green spaces and walking/biking trails, Lakefront Villas provides the perfect blend of nature and modern living. Experience the comfort and convenience of our idyllic community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments For Rent with Fitness Center",
      "seo_description": "Explore Lakefront Villas for apartments for rent with fitness center access. Enjoy modern amenities and a serene lakeside community in West Houston, Texas.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-spa",
      "search_query": "Apartments For Rent Near Me with Spa",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Spa",
      "h2_subtitle": "Lakefront Villas offers a heated spa and serene lakeside living. Enjoy modern amenities and a tranquil setting in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent near me with spa access in a tranquil lakeside community. Located in West Houston, our community features a resort-inspired pool with a heated spa, perfect for relaxation and rejuvenation. Our one, two, and three bedroom apartments on Barker Cypress Road offer sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a 24/7 fitness center, clubhouse, and pet play area. With sprawling green spaces and walking/biking trails, Lakefront Villas provides the perfect blend of nature and modern living. Experience the comfort and convenience of our idyllic community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments For Rent with Spa",
      "seo_description": "Explore Lakefront Villas for apartments for rent with spa access. Enjoy modern amenities and a serene lakeside community in West Houston, Texas.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-washer-dryer",
      "search_query": "Apartments For Rent Near Me with Washer/Dryer",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Washer/Dryer",
      "h2_subtitle": "Lakefront Villas offers in-unit washer/dryer and serene lakeside living. Enjoy modern interiors and a tranquil setting in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent near me with washer/dryer in a peaceful lakeside community. Located in West Houston, our apartments feature convenient in-unit washer/dryer, making laundry day a breeze. Our one, two, and three bedroom homes on Barker Cypress Road offer sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With sprawling green spaces and walking/biking trails, Lakefront Villas provides the perfect blend of nature and modern living. Experience the comfort and convenience of our idyllic community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments For Rent with Washer/Dryer",
      "seo_description": "Explore Lakefront Villas for apartments for rent with a washer/dryer. Enjoy modern interiors and a serene lakeside community in West Houston, Texas.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-texas-childrens-hospital",
      "search_query": "Apartments For Rent In Houston, TX, Near Texas Children's Hospital West Campus",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Texas Children's Hospital West Campus",
      "h2_subtitle": "Lakefront Villas offers convenient living near Texas Children's Hospital West Campus. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Texas Children's Hospital West Campus. Our community offers a serene setting with sprawling green spaces and a tranquil lakeside gazebo, perfect for families seeking proximity to expert pediatric care. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to Texas Children's Hospital West Campus, Lakefront Villas provides the perfect blend of convenience and comfort for families in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near Texas Children's Hospital",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near Texas Children's Hospital West Campus. ",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-aesthetic-surgery",
      "search_query": "Apartments For Rent In Houston, TX, Near Aesthetic Center for Plastic Surgery",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near Aesthetic Center for Plastic Surgery",
      "h2_subtitle": "Lakefront Villas offers convenient living near the Aesthetic Center for Plastic Surgery. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near the Aesthetic Center for Plastic Surgery. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, ideal for those seeking proximity to expert aesthetic care. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to the Aesthetic Center for Plastic Surgery, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near Aesthetic Center",
      "seo_description": "Explore Lakefront Villas for apartments in Houston, TX, near Aesthetic Center for Plastic Surgery. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-breath-life",
      "search_query": "Apartments For Rent In Houston, TX, Near Breath Life Research Institute",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Breath Life Research Institute",
      "h2_subtitle": "Lakefront Villas offers convenient living near Breath Life Research Institute. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Breath Life Research Institute. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, perfect for those seeking proximity to innovative research facilities. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to Breath Life Research Institute, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near Breath Life Research Institute",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near Breath Life Research Institute. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-hca-healthcare",
      "search_query": "Apartments For Rent In Houston, TX, Near HCA Houston Healthcare West",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near HCA Houston Healthcare West",
      "h2_subtitle": "Lakefront Villas offers convenient living near HCA Houston Healthcare West. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near HCA Houston Healthcare West. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, ideal for those seeking proximity to comprehensive healthcare services. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to HCA Houston Healthcare West, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apts Near HCA Houston Healthcare West",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near HCA Houston Healthcare West. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-philips-medical",
      "search_query": "Apartments For Rent In Houston, TX, Near Philips Medical Services",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Philips Medical Services",
      "h2_subtitle": "Lakefront Villas offers convenient living near Philips Medical Services. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Philips Medical Services. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, perfect for those seeking proximity to medical services. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to Philips Medical Services, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near Philips Medical Services",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near Philips Medical Services. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-hcc-katy",
      "search_query": "Apartments For Rent In Houston, TX, Near HCC - Houston Community College - Katy Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near HCC - Katy Campus",
      "h2_subtitle": "Lakefront Villas offers convenient living near HCC - Katy Campus. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near HCC - Houston Community College - Katy Campus. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, ideal for students and faculty seeking proximity to educational facilities. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to HCC - Katy Campus, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near HCC - Katy Campus",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near HCC - Katy Campus. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-houston-tx-near-hcc-spring-branch",
      "search_query": "Apartments For Rent In Houston, TX, Near Houston Community College - Spring Branch Campus",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near HCC - Spring Branch Campus",
      "h2_subtitle": "Lakefront Villas offers convenient living near HCC - Spring Branch Campus. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Houston Community College - Spring Branch Campus. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, perfect for students and faculty seeking proximity to educational facilities. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to HCC - Spring Branch Campus, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apts Near HCC - Spring Branch Campus",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near HCC - Spring Branch Campus. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-houston-christian-university",
      "search_query": "Apartments For Rent In Houston, TX, Near Houston Christian University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near Houston Christian University",
      "h2_subtitle": "Lakefront Villas offers convenient living near Houston Christian University. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Houston Christian University. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, ideal for students and faculty seeking proximity to educational facilities. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to Houston Christian University, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near Houston Christian University",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near Houston Christian University. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-houston-tx-near-hcc-stafford",
      "search_query": "Apartments For Rent In Houston, TX, Near Houston Community College - Stafford Campus",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near HCC - Stafford Campus",
      "h2_subtitle": "Lakefront Villas offers convenient living near HCC - Stafford Campus. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Houston Community College - Stafford Campus. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, perfect for students and faculty seeking proximity to educational facilities. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to HCC - Stafford Campus, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near HCC - Stafford Campus",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near HCC - Stafford Campus. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-sanford-brown",
      "search_query": "Apartments For Rent In Houston, TX, Near Sanford-Brown College",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near Sanford-Brown College",
      "h2_subtitle": "Lakefront Villas offers convenient living near Sanford-Brown College. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Sanford-Brown College. Our community provides a serene setting with sprawling green spaces and a tranquil lakeside gazebo, ideal for students and faculty seeking proximity to educational facilities. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of community amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With easy access to Sanford-Brown College, Lakefront Villas offers the perfect blend of convenience and comfort for residents in West Houston. Experience the ideal retreat with modern living and a supportive community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near Sanford-Brown College",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near Sanford-Brown College. Enjoy modern amenities and a serene lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-mayde-creek",
      "search_query": "Apartments For Rent In Houston, TX, Near Mayde Creek Elementary School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Mayde Creek Elementary School",
      "h2_subtitle": "Lakefront Villas offers family-friendly living just 3.3 km from Mayde Creek Elementary School. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Mayde Creek Elementary School, just 3.3 km away. Our community is perfect for families seeking a home within the Katy Independent School District. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of family-friendly amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With sprawling green spaces and a tranquil lakeside gazebo, Lakefront Villas provides the perfect blend of nature and modern living. Experience the ideal retreat with a supportive community and convenient access to quality education today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apts  Near Mayde Creek Elementary School",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near Mayde Creek Elementary School. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-mayde-creek",
      "search_query": "Apartments For Rent In Houston, TX, Near Mayde Creek Junior High",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston, TX, Near Mayde Creek Junior High",
      "h2_subtitle": "Lakefront Villas offers family-friendly living just 3.1 km from Mayde Creek Junior High. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Mayde Creek Junior High, only 3.1 km away. Our community is ideal for families seeking a home within the Katy Independent School District. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of family-friendly amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With sprawling green spaces and a tranquil lakeside gazebo, Lakefront Villas provides the perfect blend of nature and modern living. Experience the ideal retreat with a supportive community and convenient access to quality education today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near Mayde Creek Junior High",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near Mayde Creek Junior High. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6300377863421952",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-mayde-creek-high",
      "search_query": "Apartments For Rent In Houston, TX, Near Mayde Creek High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston, TX, Near Mayde Creek High School",
      "h2_subtitle": "Lakefront Villas offers family-friendly living just 2.2 km from Mayde Creek High School. Enjoy serene lakeside views and modern amenities in West Houston, Texas.",
      "page_copy": "Welcome to Lakefront Villas, where you can find apartments for rent in Houston, TX, near Mayde Creek High School, only 2.2 km away. Our community is perfect for families seeking a home within the Katy Independent School District. Located on Barker Cypress Road, our one, two, and three bedroom apartments feature sophisticated interiors and stunning lakeside views. Enjoy a range of family-friendly amenities, including a resort-inspired pool, heated spa, and 24/7 fitness center. With sprawling green spaces and a tranquil lakeside gazebo, Lakefront Villas provides the perfect blend of nature and modern living. Experience the ideal retreat with a supportive community and convenient access to quality education today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019f6c0f-5c79-7590-9e5b-278422227a02",
        "storage_key": "property/6300377863421952/019f6c0f-5c79-7590-9e5b-278422227a02.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
      "blank_image_media": {
        "alt_text": "Exterior of modern apartment building with large windows and balconies",
        "public_id": "019f6c0f-65fe-72be-b99d-e7143b578546",
        "storage_key": "property/6300377863421952/019f6c0f-65fe-72be-b99d-e7143b578546.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Lakefront Villas | Apartments Near Mayde Creek High School",
      "seo_description": "Explore Lakefront Villas for apartments for rent in Houston, TX, near Mayde Creek High School. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2169"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471429"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4576999"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WLHJRSB"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://lakefrontv.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443916050"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/4d7p1kz8wkx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/ddd56b5f-bff7-44e8-8df5-8a4bb906b88c"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "832-802-6415"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkRwbVF1YnNrOU8zbDUzR0RrRUVmSFE9PSIsInZhbHVlIjoiWGpmdXNGeEJHY0hHUFJoOUgzUVZsUT09IiwibWFjIjoiNTk2MDQ3YTUwOWY3ZjVjOGE3NjdhMTI3NGZmMjRjODE3MDcxYjNhYTM5N2UwN2ZjYjRlMDI0ODNmYWFiZDMxZCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_qb_id": "2169",
  "custom_repli_id": "2376471429",
  "custom_realpage_id": "4576999",
  "custom_google_gtm_id": "GTM-WLHJRSB",
  "custom_rollout_phase": "2",
  "custom_betterbot_script": "<script src=\"https://lakefrontv.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_hubspot_company_id": "8443916050",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/4d7p1kz8wkx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/ddd56b5f-bff7-44e8-8df5-8a4bb906b88c",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "832-802-6415",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkRwbVF1YnNrOU8zbDUzR0RrRUVmSFE9PSIsInZhbHVlIjoiWGpmdXNGeEJHY0hHUFJoOUgzUVZsUT09IiwibWFjIjoiNTk2MDQ3YTUwOWY3ZjVjOGE3NjdhMTI3NGZmMjRjODE3MDcxYjNhYTM5N2UwN2ZjYjRlMDI0ODNmYWFiZDMxZCJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-09-01T19:37:27.363Z';
